import { defineStore } from 'pinia'
import echarts from 'echarts'
var labelData1 = [];
var labelData2 = [];
for (var i = 0; i < 15; ++i) {
  labelData1.push({
    value: 1,
    name: i,
    itemStyle: {
      normal: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: "rgb(190, 188, 188)",
          },
          {
            offset: 1,
            color: "rgb(190, 188, 188)",
          },
        ]),
      },
    },
  });
}
for (var i = 0; i < 20; ++i) {
  labelData2.push({
    value: 1,
    name: i,
    itemStyle: {
      normal: {
        color: "#251f45",
      },
    },
  });
}
const useStore = defineStore('store', {
  state: () => {
    return {
      basicData: {
        // 安全运行天数
        SafeOperationDays: {
          id: 1,
          Title: ['安全运行天数', '/Safe operation days'],
          StartTime: '2020.0808',
          ElapsedTime: '1524'
        },
        // 报警事件
        AlarmEvent: {
          id: 2,
          Title: ['报警事件', '/Alarm event'],
          table: {
            thead: ['序号', '检测点', '告警类型', '告警时间', ''],
            tbody: [
              {
                i: 1,
                CheckPoint: '消防泵房',
                Type: '事故告警',
                Time: '2022/8/14 10:00:00'
              },
              {
                i: 2,
                CheckPoint: '消防泵房',
                Type: '事故告警',
                Time: '2022/8/14 10:00:00'
              },
              {
                i: 3,
                CheckPoint: '消防泵房',
                Type: '事故告警',
                Time: '2022/8/14 10:00:00'
              },
              {
                i: 4,
                CheckPoint: '消防泵房',
                Type: '事故告警',
                Time: '2022/8/14 10:00:00'
              },
              {
                i: 5,
                CheckPoint: '消防泵房',
                Type: '事故告警',
                Time: '2022/8/14 10:00:00'
              },
              {
                i: 6,
                CheckPoint: '消防泵房',
                Type: '事故告警',
                Time: '2022/8/14 10:00:00'
              },
            ]
          }
        },
        option: {
          home: [
            {
              id: 3,
              name: '设备状态统计',
              active: true,
            },
            {
              id: 4,
              name: '告警统计',
              active: true,
            },
            {
              id: 5,
              name: '能耗展示',
              active: true,
            },
            {
              id: 6,
              name: '碳排放/标煤',
              active: true,
            },
            {
              id: 7,
              name: '用能趋势分析',
              active: true,
            },
            {
              id: 8,
              name: '成本目标',
              active: true,
            },
          ],
          electricity: [
            {
              id: 3,
              name: '设备状态统计',
              active: true,
            },
            {
              id: 4,
              name: '成本目标',
              active: true,
            },
            {
              id: 5,
              name: '能耗分布',
              active: true,
            },
            {
              id: 6,
              name: '碳排放/标煤',
              active: true,
            },
            {
              id: 7,
              name: '负荷率/功率因数',
              active: true,
            },
            {
              id: 8,
              name: '当月次数排行',
              active: true,
            },
            {
              id: 9,
              name: '建筑能耗',
              active: false,
            },
            {
              id: 10,
              name: '三相不平衡度',
              active: false,
            },
            {
              id: 11,
              name: '用能趋势分析',
              active: false,
            },
          ],
          pipenetwork: [
            {
              id: 3,
              name: '设备状态统计',
              active: true,
            },
            {
              id: 4,
              name: '成本目标',
              active: true,
            },
            {
              id: 5,
              name: '碳排放、标煤',
              active: true,
            },
            {
              id: 6,
              name: '建筑能耗',
              active: true,
            },
            {
              id: 7,
              name: '用能趋势分析',
              active: true,
            },
          ],
          maintain:[
            {
              id: 3,
              name: '设备状态统计',
              active: true,
            },
            {
              id: 4,
              name: '用能趋势分析',
              active: true,
            },
            {
              id: 5,
              name: '空调开关状态',
              active: true,
            },
            {
              id: 6,
              name: '建筑能耗',
              active: true,
            },
            
            {
              id: 7,
              name: '成本目标',
              active: true,
            },
            
          ],
          monitor:[
            {
              id: 3,
              name: '设备状态统计',
              active: true,
            },
          ]
        },
        // 模块激活个数
        modelactiveCount:0,
      },
      // home页面
      home: {
        // 设备状态统计
        EquipmentStatistics: {
          id: 3,
          Title: ['设备状态统计', '/Equipment status statistics'],
          Option: {
            color: ['#ffb400', '#36ddff', '#00a7f3', '#36ffc4', '#488dff'],
            tooltip: {
              trigger: "item",
              position: 'right',
              formatter: "{b}: {c} 台"
            },
            graphic: {
              elements: [{
                type: "image",
                style: {
                  image: 'data:image/png;base64,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',
                  width: 105,
                  height: 105
                },
                left: 'center',
                top: "center",
                position: [100, 100]
              }]
            },
            title: {
              text: '{a|' + 2500 + '}\n{b|设备总数}',
              top: 'center',
              textAlign: "center",
              left: "45%",
              textStyle: {
                color: "#fff",
                rich: {
                  a: {
                    fontSize: 20,
                    lineHeight: 20,
                    fontWeight: 'bold'
                  },
                  b: {
                    fontSize: 16
                  }
                }
              }
            },
            legend: {
              show: false,
            },
            toolbox: {
              show: false
            },
            series: [
              {
                name: "",
                type: "pie",
                radius: ['70%', '85%'],
                center: ["50%", "50%"],
                label: {
                  normal: {
                    show: false
                  }
                },
                // hoverAnimation: false,
                hoverOffset: 8,
                data: [
                  {
                    name: "电表(台)",
                    value: 100,
                  },
                  {
                    name: "水表(台)",
                    value: 200
                  },
                  {
                    name: "电气火灾(台)",
                    value: 200
                  },
                  {
                    name: "空调(台)",
                    value: 100
                  },
                  {
                    name: "视频监控(台)",
                    value: 100
                  }
                ]
              },
              {
                name: "",
                type: "pie",
                radius: ['92%', '90%'],
                center: ["50%", "50%"],
                label: {
                  normal: {
                    show: false
                  }
                },
                hoverAnimation: false,
                itemStyle: {
                  normal: {
                    borderColor: "rgba(19,22,24,1)",
                    borderWidth: 0
                  }
                },
                color: 'rgb(66, 90, 114)',
                data: [0]
              }
            ]
          }
        },
        // 告警统计
        AlarmStatistics: {
          id: 4,
          Title: ['告警统计', '/Alarm Statistics'],
          option: {
            tooltip: {
              //雷达图的tooltip不会超出div，也可以设置position属性，position定位的tooltip 不会随着鼠标移动而位置变化，不友好
              confine: true,
              enterable: true, //鼠标是否可以移动到tooltip区域内
            },
            radar: {
              name: {
                textStyle: {
                  color: '#dce5fade',
                  fontSize: 12,
                },
              },
              shape: 'polygon',
              center: ['50%', '50%'],
              radius: '80%',
              startAngle: 120,
              scale: true,
              axisLine: {
                lineStyle: {
                  color: '#455a70',
                },
              },
              splitLine: {
                show: true,
                lineStyle: {
                  width: 1,
                  color: '#455a70', // 设置网格的颜色
                },
              },
              indicator: [
                {
                  name: '漏损告警',
                  max: 100,
                },
                {
                  name: '火灾告警',
                  max: 100,
                },
                {
                  name: '能耗告警',
                  max: 100,
                },
                {
                  name: '能耗告警',
                  max: 100,
                },
                {
                  name: '通讯告警',
                  max: 100,
                },
                {
                  name: '设备告警',
                  max: 100,
                },
                {
                  name: '其他',
                  max: 100,
                },
              ],
              splitArea: {
                show: true,
                areaStyle: {
                  color: ['#ffb40000', 'rgba(35, 49, 66,1)',]
                }
              },
            },
            grid: {
              position: 'center',
            },
            polar: {
              center: ['50%', '50%'], // 默认全局居中
              radius: '0%',

            },
            angleAxis: {
              min: 0,
              interval: 5,
              clockwise: false,
              axisTick: {
                show: false,
              },
              axisLabel: {
                show: false,
              },
              axisLine: {
                show: false,
              },
              splitLine: {
                show: false,
              },
            },
            radiusAxis: {
              min: 0,
              interval: 20,
              splitLine: {
                show: false,
              },
            },
            series: [
              {
                name: '雷达图',
                type: 'radar',
                symbol: 'circle', // 拐点的样式，还可以取值'rect','angle'等
                symbolSize: 10, // 拐点的大小
                itemStyle: {
                  normal: {
                    color: '#ffb400',
                  },
                },
                areaStyle: {
                  normal: {
                    color: '#97761e',
                    opacity: 0.8,
                  },
                },
                lineStyle: {
                  width: 2,
                  color: '#ffb400',
                },
                label: {
                  normal: {
                    show: true,
                    formatter: (params) => {
                      return params.value;
                    },
                    color: '#fff',
                  },
                },
                data: [
                  {
                    value: [75, 75, 75, 75, 75, 75, 75],
                  },
                ],
              },
            ],
          }
        },
        // 能耗展示
        EnergyConsumptionDisplay: {
          id: 5,
          Title: ['能耗展示', '/Energy consumption display'],
          Option: {
            tooltip: {
              trigger: 'item',
              position: function (pos, params, dom, rect, size) {
                if(pos[0] > 190){
                  return 'left'
                }else{
                  return 'right'
                }
              },
              textStyle: {
                color: '#fff'
              },
              formatter: (params)=>{
                if(params.seriesName === 'a'){
                  return params.name + ':' + params.value
                }
              }
            },
            // legend: {
            //   show: true
            // },
            grid: {
              left: '0%',
              right: '10%',
              bottom: '0%',
              top: '8%',
              containLabel: true
            },
            xAxis: {
              boundaryGap:false, // 不留白，从原点开始
              axisLabel: {
                interval: 0, //强制显示文字
                color:'#9da7be'
              },
              axisTick: {
                show: false // 不显示坐标轴刻度线
              },
              type: 'category',
              data: ['海关查验库', '检查大厅', '消防水泵放', '设备用房']
            },
            yAxis: {
              show: false,
              axisLine: {       //y轴
                show: false
              },

            },
            series: [
              {
                name: 'a',
                type: 'bar',
                stack: 'account1',
                barWidth: 20,
                itemStyle: {
                  color: '#488dff20',
                  // 经过变色
                  emphasis: {
                    color:"#488dff20"
                  },
                },
                data: [300, 100, 300, 300],
                label: {
                  show: true,
                  color: '#fff',
                  position: 'top',
                  fontSize: 12
                },
              },
              {
                name: 'a',
                type: 'bar',
                stack: 'account2',
                barWidth: 20,
                itemStyle: {
                  color: '#ffb40020',
                  // 经过变色
                  emphasis: {
                    color:"#ffb40020"
                  },
                },
                data: [250, 250, 250, 250],
                label: {
                  show: true,
                  color: '#fff',
                  position: 'top',
                  fontSize: 12
                },
              },
              {
                name: '',
                type: 'bar',
                stack: 'account1',
                barWidth: 20,
                itemStyle: {
                  color: '#488dff'
                },
                data: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],

              },
              {
                name: '',
                type: 'bar',
                stack: 'account2',
                barWidth: 20,
                itemStyle: {
                  color: '#ffb400'
                },
                data: [5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5]
              },

            ]
          }
        },
        // 碳排放/标煤
        CarbonEmission: {
          id: 6,
          Title: ['碳排放/标煤', '/Carbon emission/standard coal'],
          Option: {
            graphic: {
              elements: [{
                type: "image",
                style: {
                  image: 'data:image/png;base64,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',
                  width: 110,
                  height: 110
                },
                left: 'center',
                top: "center",
                position: [100, 100]
              }]
            },
            title: [
              {
                text: '总',
                textStyle: {
                  color: '#fff',
                  fontSize: 20,
                  fontWeight: 'bold',
                },
                itemGap: 20,
                left: '38%',
                top: '38%',
              },
            ],
            tooltip: {
              trigger: 'item',
              position: 'right',
              backgroundColor: 'rgba(200,231,242,0.9)',
              textStyle: {
                color: 'rgba(20,34,54,1)'
              },
              formatter: (params)=>{
                if(params.name !== ''){
                  return params.name + ':' + params.data.value + '%'
                }
              }

            },
            series: [
              {
                name: '环比',
                type: 'pie',
                radius: ['80%', '70%'],
                avoidLabelOverlap: false,
                hoverAnimation: false,
                label: {
                  normal: {
                    show: false,

                  },
                },
                data: [
                  {
                    value: 35,
                    name: '',
                    // tooltip: {
                    //   show: false,
                    // },
                    itemStyle: {
                      normal: {
                        color:"#488dff40"
                      },
                    // 经过变色
                    emphasis: {
                      color:"#488dff40"
                    },
                  },
                  },
                  {
                    value: 65,
                    name: '环比值',
                    itemStyle: {
                      normal: {
                        color: '#488dff'
                      },
                    }
                  }
                ]
              },
              {
                name: '同比',
                type: 'pie',
                radius: ['60%', '50%'],
                avoidLabelOverlap: false,
                hoverAnimation: false,
                label: {
                  normal: {
                    show: false,
                  },
                  
                },
                data: [
                  {
                    value: 35,
                    name: '同比值',
                    itemStyle: {
                      normal: {
                        color: '#ffb400'
                      },

                    }

                  },
                  {
                    value: 65,
                    name: '',
                    itemStyle: {
                      normal: {
                        color: '#ffb40040'
                      },
                      // 经过变色
                    emphasis: {
                      color:"#ffb40040"
                    },
                    }
                  }
                ]
              },
            ]
          }
        },
        // 用能趋势分析
        EnergyConsumptionTrend: {
          id: 7,
          Title: ['用能趋势分析', '/Energy trend analysis'],
          Option: {
            grid: {
              left: '0%',
              right: '5%',
              top: '20%',
              bottom: '0%',
              containLabel: true
            },
            tooltip: {
              show: true,
              trigger: 'axis',
            },
            legend: {
              show: false,
            },
            xAxis: { // 横坐标轴
              boundaryGap: false,
              type: 'category',
              axisLine: {
                show: true,
                lineStyle: {
                  color: '#2f3848',
                  width: 2,
                }
              },
              axisLabel: {
                color: '#778194',
              },
              splitLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              data: ['0:00', '3:00', '6:00', '9:00', '12:00', '15:00', '18:00', '21:00', '24:00']
            },
            yAxis:{
              type: 'value',
              name: '(tce)',
              padding: 5,
              // max: 1000,
              splitLine: {
                show: false,
              },
              nameTextStyle: {
                color: "#9da7be",
                nameLocation: "start",
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: '#2f3848',
                  width: 2,
                }
              },
              axisLabel: {
                show: true,
                margin: 10,
                textStyle: {
                  color: '#9da7be'
                }
              },
              axisTick: {
                show: false
              }
            },
            series: [
              {
                name: '水',
                type: 'line',
                smooth: true,
                stack: '总量',
                symbolSize: 0,
                itemStyle: {
                  normal: {
                    color: 'rgb(72, 141, 255)',
                    lineStyle: {
                      color: "rgb(72, 141, 255)",
                      width: 2
                    },
                  }
                },
                areaStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: 'rgba(72, 141, 255, 1)'
                      },
                      {
                        offset: 1,
                        color: 'rgba(72, 141, 255, 0.2)'
                      }
                    ], false),
                  }
                },
                data: [220, 330, 191, 234, 290, 330, 310, 201, 154]
              },
              {
                name: '总',
                type: 'line',
                smooth: true,
                stack: '总量',
                symbolSize: 0,
                itemStyle: {
                  normal: {
                    color: '#fff',
                    lineStyle: {
                      color: "#fff",
                      width: 2
                    },
                  }
                },
                areaStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: 'rgba(255, 255, 255, 1)'
                      },
                      {
                        offset: 1,
                        color: 'rgba(255, 255, 255, 0.1)'
                      }
                    ], false),
                  }
                },
                data: [220, 330, 191, 234, 290, 330, 310, 201, 154]
              },
              {
                name: '水',
                type: 'line',
                smooth: true,
                stack: '总量',
                symbolSize: 0,
                itemStyle: {
                  normal: {
                    color: 'rgb(255, 180, 0)',
                    lineStyle: {
                      color: "rgb(255, 180, 0)",
                      width: 2
                    },
                  }
                },
                areaStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: 'rgba(255, 180, 0, 1)'
                      },
                      {
                        offset: 1,
                        color: 'rgba(255, 180, 0, 0.1)'
                      }
                    ], false),
                  }
                },
                data: [220, 330, 191, 234, 290, 330, 310, 201, 154]
              }

            ]
          }
        },
        // 成本目标
        CostTarget: {
          id: 8,
          Title: ['成本目标', '/Cost target'],
          Option: {

          }
        }
      },
      electricity: {
        // 设备状态统计
        EquipmentStatistics: {
          id: 3,
          Title: ['设备状态统计', '/Equipment status statistics'],
          Option: {
            color: ['#ffb400', '#488dff'],
            tooltip: {
              trigger: "item",
              // position: function (pos, params, dom, rect, size) {
              // },
              textStyle: {
                color: '#fff'
              },
              formatter: (params)=>{
                if(params.seriesName === 'val'){
                  return params.name + ':' + params.value
                }
              }
            },
            graphic: {
              elements: [{
                type: "image",
                style: {
                  image: 'data:image/png;base64,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',
                  width: 105,
                  height: 105
                },
                left: 'center',
                top: "center",
                position: [100, 100]
              }]
            },
            title: {
              text: '{a|' + 1000 + '}\n{b|设备总数}',
              top: 'center',
              textAlign: "center",
              left: "48%",
              textStyle: {
                color: "#fff",
                rich: {
                  a: {
                    fontSize: 18,
                    lineHeight: 28,
                    fontWeight: 'bold'
                  },
                  b: {
                    fontSize: 12,
                    color:'#b4caf3'
                  }
                }
              }
            },
            legend: {
              show: false,
            },
            toolbox: {
              show: false
            },
            series: [
              {
                name: "val",
                type: "pie",
                radius: ['70%', '85%'],
                center: ["50%", "50%"],
                label: {
                  normal: {
                    show: false
                  }
                },
                // hoverAnimation: false,
                hoverOffset: 5,
                data: [
                  {
                    name: "电表(台)",
                    value: 50,
                  },
                  {
                    name: "电气火灾(台)",
                    value: 250
                  },
                ]
              },
              {
                name: "",
                type: "pie",
                radius: ['92%', '90%'],
                center: ["50%", "50%"],
                label: {
                  normal: {
                    show: false
                  }
                },
                hoverAnimation: false,
                itemStyle: {
                  normal: {
                    borderColor: "rgba(19,22,24,1)",
                    borderWidth: 0
                  }
                },
                color: 'rgb(66, 90, 114)',
                data: [0]
              }
            ]
          },
          dianbiaoData: {
            total: 500,
            onLine: 250,
            offLine: 250
          },
          dianqiData: {
            total: 500,
            onLine: 250,
            offLine: 250
          },
        },
        // 成本目标
        CostTarget: {
          id: 4,
          Title: ['成本目标', '/Cost target'],
          // 实际用能
          actual: 1000,
          // 目标用能
          target: 1000,
          // 同比 100%
          yearOnYear: 100,
          // 环比
          ringRatio: 100,
          data: [
            // {

            //     xAxis: {
            //       max: 10,
            //       show: false,
            //       splitLine: {
            //         show: false,
            //       },
            //     },
            //     yAxis: {
            //       max: 10,
            //       show: false,
            //       splitLine: {
            //         show: false,
            //       },
            //     },
            //     series: [
            //       {
            //         type: "scatter",
            //         zlevel: 60,
            //         itemStyle: {
            //           opacity: 1, // 控制 满意icon的 透明度
            //         },
            //         data: [
            //           {
            //             // 外圈 点状圈
            //             value: 5,
            //             // symbol: "image://" +  "/assets/img/电echarts.png",
            //             symbolSize: 280,
            //             symbolOffset: [0, 0],
            //           },
            //         ],
            //       },
            //     ],
            // },
            {
              graphic: {
                elements: [{
                  type: "image",
                  style: {
                    image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH0AAAB8CAYAAABE3L+AAAAgAElEQVR4nOV9CZxkVXX3ufctVd0zNcMyDIgMAiIMMDBIXBtXFKJiUDEKGlvFn/6UT7/kS8C4RKNBTWI0xsSFYPyisVWIAReIaAQlijaKBHFYws6wDcOwDsV0V9V7797vd849575bb6q7Xi8zPeS7TFFL1/LeO/fs/3OOsv8O/7+tDwPAGQBwHwCcCgC/rXH+DQDo/k+5TnoXOIaFrOUAcCQAfAUAvgMAzxryXYcAwFkAsBIA1gLAZ4e8fy8AuBIAOgDwHwDQWvpTXviKn2DHi5t0PwA4kG9IlDcAwNP578cBwAEA8EjN71ND/v4eAHgmPz4BAE4DgH9YwPHvEuuJQvQ1AHAYc+pI5W9PDh6v4PfORPSbAeDjAHAmAGzi+9nWVOVvncU7paVbu7JOXwYA6wDgKADYbZb3PQ8ATuLHlwPAiwDALNIxoDj/KgC8EAB+BABvBYDeLO//QwB4BwBcCwB/BAAPLNJxLOraFYmOIvsZzNkRi/SZiGjZIEsBoA0AFy2hwbUeAK4Jnv9fAHj7Eh3LrGtXEu+rmWufWnm9SnAk6q0AcDsAbNyFRO6qyvO9l+g4hq5dgei7A8DzAeDQWd5TAMAtAHADE7rYicdXd/0UAFBuvhIAtgLAJ3fBY6S1lOIdfd/nAsAxLMYHrUcB4DcAcD0ATC/Zkc5t7QsAjwHA47vqAS4Vpz8NAF7KfvagtZn945tZbz+R1qYax9pkgw+N1S8DwIM78/x2NtFHAeB4dr0GrS0A8AvW2f+T19nsCeB6C3so2c46351JdAymvJx3d3VtY3fr2p14PEu5jgt+ey0HlG7ZWcezM4iu2c99xoC/oWV+FQBcMcT/nfOamGyh6jiIvYGD2DvYgzddylLHsP4tOKDzMKuWu/h28/hYe1GPi9d32afHdRMA3LEDfmPGtaMNuWUcONlvwN/u53j2/Qv9kYnJVoPDpbixnmkMHGIs7F0YMMZYKAxYa8GicUD3gZWglL9XWoHC55EGpbVSkYYiUrARFBmTaGP8anysvXGhx8uG6ykAsA8AfJ3V2k5bO5LoyFknz5CkuIpdnHlHziYmW3uwujjBGHhObqCZ5dYggYsCb9YaC9bgcyK6BXwuZqFhA1Fj/J0Jj8RG6hPRFagoAhU54qskBo2PkwjuAgU/AYDv43mMj7UXK/q309aOIvqBzOFp5XV0u344X0NtYrIVs9X/hsLA87Pc6l4OJs+tyQuwWQEGiV0woQ3dHLGRw40lTqeFDxUnXBQ/UI7YxPVI4FgDEZyIH9FzHcdKxRHoNFE6jWALKLgAAM4dH2vfufDLtnPWjiD64cyB1bTtJg6TPjbXL5yYbGHsfRwsnNbNYY9eZg1yNROciI1EzwtriMuJ6JY5HKBAohsW7fSNoRfo2FxEO4l3FPXa3YjTI3AbIFIqjUBHsVJpDDqJlU4T0GmsdByRIXrO+Fj78oVdvr61PzPQoto8i030o5kTqylLjEn/eK7inEX4O42Bt3Qz2+zlUHR7SHAwvdzdZ4W1ORJfOJyJbwwQh+NzPBokc5Fbq/ixCfU6czvqcXyMxI4jel3piDjbcTyJeSIw3afM8QkTvpGqKI0pkPSZ8bH2pQu8lq8AgG9zEOtqjlpWs37zWotJ9KczwcNlWXf/ei5fNDHZouCFMXB6N7OjnR4U3cwWyOHdDIjLhfDI4cY6whc52F5hnShHohsiuMK/GSKs9a+JuEdxTkdJHK6Qu9mQo/fQBmgkSuNruCNQvCOxkfAxEjphwkf0OGqknvho/J01Pta+ep7XE0Ehrw6e4+PvzfO7+tZiEX0di/Rw4XX+AcfLa6+JydZLMOfd6dknIbE7PVv0etZ0MiiQ2N2s5PAMN0BBetuiqEfKimhHQtKGYFmu8DkbdEhAfAzOeAMU4fg5TdxOasnGCrRlcZ9GTsSjro9JCihFYj1VEX6+magoSUA1YhXhBmimRPyomZJU+DYTvy6wQ9YnAOCD/NiyFN2wGMRaDKIfzLswFOkF6+/aAYeJyRYmXj6e5fDK6Z4tOl1LBEfO7vYsEbyTgSF9jvco1gswpgDbRUudxXiBr1mLRCSeRvLn/DcU90hH5GAkJr6OG8CwTR+z7i4MER+SyFn2Sjnups0Qk57XaQwqQQ7HTZCAbqYqirVSzRR0I1FRmio92gAkfNxM1aNKwYfHx9oXzeG6ohH855yb+BcA+Nc5UWWWtVCiP4n9zSR4DQl+4Vws9InJ1rPAwuene3b1dNfm010okPBdIroT6ajLkZszJDrqbWNt1gNTANgst6S7UXSjOEbDDrk+0oZ0Nz7GzyKh8PeynLjaWe661O+4QZIINIt4MNbZorF32Zzyx8+m7MLhd8YxEVo3G0CEx8dpSgTXy5oqRq4fSVWUxHA+AHxofKy9pMmjhRB9BVnULrIly3J68cY6XzAx2cILf3pewJlTXQvI3VNdm3e61nR7UExnXrSTW8b63OYG75071svAkHUOhqiI3IsyHXWLYbcNCYQbBUqPjRaJecfttDGQs2mTWIBG0s/xqA4irVUzAW15I0QRbQC04BVyOm64kRQNO6frRxoqQq5f1kRRD9FIQ8UjDYXM8K7xsfaS5RfmS/SYAYn7VF6/pIIemXFNTLYQkfq5bgYvmOo4Yk93bTHtxbo1nQ4UPSY2WudIfNTXORpsaLgZ48SzIR8d0GDD570CjJPKQLI+pLSI9sgZap7jSfRLkCYCba0iQy+N/N+B3ThwlrxG7idVQbobpQGK+UShpFCjTUVivpFCNIr6van0SKri0aaKRxuqqzV8YHys/Z15Xf0Fruijb5zXF5wwAOGCUbZf1vnwxGQLwYvnTXft0dumbf74tM2J8B1A4hf42G0AMNNda6Z7pMNNpwumg49zg5Y76eduDyxuCiRKpK1Czkc/G8U9ErQwjkjMwURYFNW4UWywCdwGcW4aQPmaZemB7hx+HiN4vRxItuSGHAH3HjISFUoeei9JHCdtSBI5q4KlDzoBkXrFdfc2YMPdjV+tX7Mjwvszr/kQ/TD2GcN1B1vqQ9fEZGstWDh/W9c+CYm9rUO3grm9mJ6GYqpnDT5GEY66HYmxrQNFVhinv9kdK9hIQ2LbMgoHTp+L7+2IJr420hM3QMIcHLNVbpnYheGNAP4e30+ROvIOLP6eIg7H31TKKhIm6DYWCm0KtBmMeA+5IaVncw4Jy0bDWxSpYyMNe2+4u3HZ+jW9ueIGEBX8WgZtzClhM1eir+R4epidQ3QLGij5sA9PTLaOBAvnPd6xK6ccsZHDictLwiM3O50+1bWmR9E2Y1HcFwVZ59a5W5bEOjBhUKQqdsHY9SICIxFRvyKhwyCLkwwUhPFSIB6wEeiHFOlwiszje/0xKEVGIf4OqhdjncOPx5lzYsdwVNA697EM/jvCo1Q4Ko7gwA13N340R8Jjsuq9gV11Sd0PzlWnv6GSMSvqZokmJlsHW+Twjl35+LTNUKwjNyPhp1mkd3vOJesWpM9JLKIZjkZYxgZbElmFFxovZMzulmHdzLF1K4TUA0oZmNvdyavSmJPHEskTXY+eAFr0ufHeAf4G+u1E/Jj0ehDK1U59JJHT+RS5i0GPpmjdq2i0CdFoQ5FRN9pU0fIRFS8b0XEjgXPRLx8fa9ch/O6cBpb1ACe4aq255NOPHpAivbwmwZ8EFr4ZEhw5exsab8zh0+SLg0HLHXVmVhjMmEGvB4ZYWDlril0zWkQcTewonEselbXO/xYXDFxo1elo6wI4uDGYE4lYWiz42H0XsBiOrON2+i423FADiP6n7ys4vKsVJBZoUypAd1FbZ0gqTPmhOvIehWVm5zPB3fLGNCZA5V/XoAVK1+s4KAZzDdrUFe/LOQATbpK7uABg1jUx2cLUKor0NSjKHxeCs1ifcm5agQYainUU5wVZP6UYNcZZQZnT22hdSzbML80iO+a0KBKI06N9BBcRL/lz1O1aUqm6tNTxdcvcKypBpAmLfuBgEC3FxiMeqWXbQisy9qzT/GwoKuXu3eYJ8vkY41fPvu7exkPr1/TqEPH7HB/5GRdkbltsop9Qcc/wVC8YhjmfmGzhQX1jumvXEXejpR4QnEQ76u8uxdbFDSNioxVOetM6EESkKThC4VK58EIkxaI45vi4ZMxC4w2JRLqdpYRm6YHBFbHS8TXcJF6nB6lYfC0rStUhOl+sfOV+k44vJV9eWcfxQIYemxy4GchBsGWiR76CviCO1Euuu7dx0/o1vWF+/FY2ni+ZC8GhZtXqvmyxh+vKmkWCf9bpwTGsv53h1i05PCA4RtkMWuc9F083yCEoNvHioIjGsCpuCrzoqROz1kr4VLvXhNDy44Upc6hMfDuSUrIENHNv4YIytKEwyIKPZROhtOANIBuPXsfNozkOLxujELtAgUKphV4GGZNouedgO5kpSG1hOLlHbiiptfDa8PVBM+bTE5Otqku8aKsO0Y+rPN9axx+fmGydmOVw2jRH2bYJodkHx8dI8I4Lr9pOz5hezxGWgA/GcQnpcM6IIWHpdSe+NYthMbKcFa8c8ZBYow0XUsXoGodgKbKGRGtQFM1tAFwSoiUrXjuxj5sKX6eNQtk2l10jQxJ8woY+x1k5ku4iDdAonc5crh/fjec41XOJI7RdpijqCOSeYujZxSqI8GiNn8MwsEVfwwy5gzm+Hq5Lh7lnE5Otfa2FT3KgJZeTEWK7uDoYFuk2N4a4QYw1hjkhIQjOhBc54hg5XlC8iEgMzVyNRBHjTI5BiCi6mAlBG0aB51xwMXQnllEhF6aMzDU06JyDPGIXRM46JwmBK8/LYxIDMNKUpVOZU0/WakXc7+BXRk31dNG0zubXCgoULFpZsi0ErRNHcHAzVR/iJgqLuoZx+rGV57dxDdlsBMdz+fRU1y7D5IkncmYNEt8ZbM416+UuuoYER3cMOUDEJf7r5swlvLTLlNGFB9azSAwRvYpfQy6WyJuIZ+s2gg6DMiB6nEOr+D4R3fw3l1iJHOfH2n/WK+LgNdUoN5DH45FL6PIFtJEzEvEYdwDbM5YyiBh2Fok4xR4Ncn5ewJsnJlvVQNiC12xEP3iA7/fzGj/4+70cju10JZQqogsKny2TzFlmDFvohG0TFwh1umYDx3LyQ5cWNy3Rs+B0vhLuFHdNYvIJG3NEtMjrZHo8QmlQdw2Y6+l98npo4IWoWTEiRZXgxuDInRW0LX/WWfHo2zMql9w1yvoZk/WA8glo2wSEx4ikz0UAwF9NTLaqNfmzrZgraHef6T2zEb2KU79pmE8+MdlaYS18eJoPuCPpUd7N9NwnUAxdHHHJhMMlMKJVaUgVgcXNBNTM0Vp0KiNWiQDONSojb0jkyAVVSC0gsFE2A0OjNP+mVw9iHKbO9fNSRTieNqIqQQT4t9hJBErBSjhXs1vn4gCSNHIwrunMFJhIQuOVJGDXgUQ6mFouk08YG/nfNQk+wvbWNVzo+fRBb5qJ6PtyR4dw1UmmnNHp2RVdtk49p7udbPDk0FhDgjsgIyORJUThuJSWcLXoXnnMvrLbMM6FkpAriXMmKnEsGmpsrWsR1Yr1u3A4Ex/wvSTGY/bxA99dXL+Uv1+4Xt4Xeg0ctvUbpuAoHnO8QsKj2nKpYTTuHPxL8AKYWcSUcin2Ab3Yd3CSathCo/t3+D0rgoKKWkRfX3l+dw0uP6AwME4Qp64AIIBy4fgaEdwhV4ngjFqlgDRlpIIoGN+sGGySKWu4XLaVoIqI6dj51rQKE4hiiaqx8aXYLxdxLZJECCYqgEW3ACTpb2nsNocYkyrw0cWeQCLGUamCgK167WIHkOe8vdFi5EQQMoDLHDrG6KDq6/LjHgFBkWlQZL+/BtHvqEB9Hxr0pkHWe2NArfhVNX7wjzs9q7o9CriQ8Ub4NgdXtohp62YuBy6GGzqxGetlSVtmDHrgVKcVwy1ErzKHAbDORw7XqkyTIncLcd7xJ5/d/4ijX7ASg+JWwLg2AHfJ4/A+uHJaR5BnPXvdb3726Nl/e8ZdEOh4/JcHeXjU75LRo4ycC99Cj1/jcC4dJ/nxLlCntTaQ5Zqs+yQD1U3AJD0oktgiQKNIe4TMOXFisvW58bH2bAAVxCO+G0EaXN79sUFvGkT0wyrwpzZb7TOuicnWQXkBJ5FIyhyHO852ue4ui3UieOEIzvFq0o9iuBmnc7WgWcKsVxgY4fg5PiYLm3z3Ugw7DlUALz3pHatOfN0fDiqpmvN66trfWbFl853d7577D1vCwgl0zwRgIaldIS4fP52nbAbgvUXRvdSdKzj1YAkdhMfegwLBG90M4xigG7EyncTa5SPq/zBBZ1tn823GNUi8V6Nv19aoEX9nN3PQJdRNHq7MnE4VKKYU695oC3LgYcZLxC5nv5Qt/V8lFrvAmXCj4EZI4tLNkve+6tQ/2ncxCC6r0VweSeBFXEFRBcCETuLSsg99d2AAhbigEQV5rFFaroMhAEbG+p7Sy8w8HXc90YV7GarRhZ5HlejLKy26gMXEjAsLEoyB18jByYEyVNmfBHJ5wVzu4hWOswsnzp0RxBeIc9TAlru/cOIXN5wYFTdLXC4y3EhXR6D2f+qRzf0OOHympgdzXkWemR9f9CVqHsDROhBcvBhynKETopJUSkoj0NsmGeP4yM1jz6XIXXIJI889CUtnJQPxNcXvfttiE/3QCpR5M6fxZlun9nKbuoMDLjdyiFXi8sIFJnLP4STNJAJGJ9zLS0Mu4rCpP0BVomBsaeU744xj5mI8CRoW3/vyk09f1EY/V17+3QfbWx8sRM2I0adLQ05JkAcCiSM5fmDpJPpfNjzj++gaoc2B9g56NRmpRitq0gjhjYHfn5hsDarxr72qRD+o8vymGl/0etQ9YX0ZcThnyUIuz33ZkYuni96TEKl8YY85HUW76HDJnNkgmyZLig6TuMRNPPfFr99rIRemur7/rc9sFtcxXD5Ny745MHGFqAz08OdluKgCeOMgwZVLJoLYQc53Z8bJ3XV1bh5d31EueZr3ComeDPDNZ03vTUy2jspyODDLrOUyI5sx8anGrMLlxsVjPDeI3taqjKpJYoVFIUAJX6JF4AhwUbcgCyYpVbSg9XNfdPJuy1fskcx27HNZm+66adtN1/1qW5B905ylo2WZwElUinHrzoNcTAnPBtAsOlZ0Z7m4wtfhIbdnLOpFNXZ97Z6TogxZWxSir6l0edpageQMWif5QsLc1ZOJH55RRSlytCkrRxkuIlzO1i/t9sKUVroYSgyA9CFXKTSMOf0pETFx1yTTdfyr37Woov2S7/3jZghcNfG7OdzrgRYqyA2I0SmbNCs8Bt8bpkFmz5XlMBDDSUTn5iKhczKGQap0MaL3nInJVrVv3UwrrobTQ6JXDbjhCEsLJzDByfDo5aVODy1zZ7E7+R2GTeVrhGsZROhrzLiyxOtIyUIpKAsTpKSYRKoBu2K3Vcm6px+3R32Szr563Wlz6YXnPCieBQQoHQFTNJIg2qdLySPnyDn7MgjkAkUEpaaNobzB6jwcVId4/fJSHfZ80SZdY/yel9Q4/MOZjvdzWZSDjgVvqPqz9872bZg+zQp4CmaQeoUjdu7qy4jQYelwwfBf4XIvzkwJSJTvlQiW6H3hFk98PmIpOBTMGetVdfyrTt9TIjeLsX750wu2TE93SFuLitGKk0ASaWPCcBQPRAKFeh2gxN/roI6O4/Tsy7stT9ePRTw3W+B7BywhiLXrrjlsvTeg6+sB4AUQBGf0gGqVWYkOAGOss31teF6UuqmgClJjQys9NL7EHZMYugRjBAPXB0cGJy1Sx82QJKXhJhwvxHjRy/5gbwc2Xpx10bmfvk+OJdyctj+3rx3Uiwsj3Aa0mCOT7Bu+t+dq6ADTqvKd+DkHpPLqgS6VYxRrs+C65rlyIt4x1nNqnGDV88og4PTdK9G5bazTZ1vHomuRu+JBw8B+n0gJiW0cIByKIDgRlhpJFC3Q5R7xKu+jVCd4MAPF3oUCEk8/+LBnje7z5INGuZJtwbe7bt/w+MZbN3TCWAEEMCwR77rE6nkbRZWgSxLnGL9ggw84ziC5Be09E849SQCLfpcJnuVc0iUdNwysRlj5EBr9JQMnkfh/xz36PKGr7s0wAw4P8FgmNLlmBWPaENtmGMwoeiokXgBmhIT1X4A7B2u9qJZiBGDMIG0MsfJz9snDYzr+Ve9cvZhc/oMLvnhfyN0erKHK5IupbGTtAjGUPZONEkQWbfCczq+XB905FENOrZOSxmgQySm2EfXUKRR5RkmsxoZ4WA9wO7e+JZw+J6JPTLb2KQzsU7AOdwfCjX34PkDAeCRMVcTzhfIJC9FzaWm8SeYKuLjBfz5lVIwX7TqCZ7/g91YtFpd3ph8rfvqDrzwkxyV6V44LoHQpo6hMsXJcnlSRZPbknESHe8+Dkbtcc0cGnUhFz+nMPDnfClanLi1NtQhzXsLp1Sb6wzh9LfVoC1p2eVQIJ0PQVfPEL1Oc3l0hERmkHdnN8RYYuzp9eerC9KUzhfj09+e99JQ9ms3ReLE4ffLH39qS5YVwtk/Rhotz8z6iSJtU+bxBH9SrF+D8IpdW9StyHe29ixcau15q0sZTZR2fUzGHz+fc5DRWVF4fRvRDnDh3Yp30tviXYqlDqc+r1UUSyBBxKAacuDDyHluKRwq52qBWLQze4HrJK9+6GgvGFuPWnW4XZ3/qPRurXoU8rur3SPdb9uxmOfVUhmXpmBmEocJ8QhZsjkLUloScS6lpDXbc8AxGjw+emGzN2VURTl9ZeX0Y0fd3NV/lQRQixrlkJ9zlEkaVk+RgSxlPD4IejHG3gT8fXlyPk2P9TwTYa/WTk0OPeOZuizXFA0X7a9/0J/ssW74yxh+0lYSEPy/Q0O12zPe+dc792UMPZJklLiKkTAxlXsFXzhiH//NQrkANAgegEk4tO4g3/qc9roAYCqtjjbLcXyfRmoYJ3DeX8xOij1ZeH9brbb/AUHMHRR0aHXMG1q0NcW9VmLLoOFOKflutHpU8tNSe5UGVScQcdMKr3raX23aLs1butmd66ts+eGDdL3vx756y91tfc+R/CSZePI+C6+QGFF3IZvb5dlF/VIWrEfevqCzG20Yc55CWp1K4yX74nIk+UtnI3Rr93laHPyzdN12UKijF5TeHxluYPIGyHtxFulQZZ5d8tARlwu8RDJxsjucdd/LqxST6XNeeq1Y3OYRqOEqIHE7MIC6oWOzGcv06n4expRQTeJhUzHDBpC/2MD6MjbUBillM1a5WlRVzw/lwDW2CYy3s7sUS63Mb9F0dtOTEfBQu8E3FpxX/XPLSUWno+UYCknUDViHrjzm2teeqvZtLSfTfXv3zh2xfH1r3OtsBHhsQRO2UDRIvVvneNx5Zo0MuF6lpBI/AfXXcFa8Tct6PI3LY7euieABkamizeWthhQTTK4BGOrCKq9YXjRPulDBq+Fy+nzgdSpCi6HvgCNYIw4wQNHHCSW9ZUi7fsvme6Y+eccpNYoBp1+Qo7HMTIO9KVcYBF4/+jXSf9LORKU0JjyPg75ByaX69aoRXV4uRzJJbeXdcwcNBzQkDo+RJsGExDEvl9VqlPpxFm4AkXEEglJavRLACSFJf7ViaNvUxz3zhqqUi+rbHt2bve/dJ12KGkQwz7jMj3kkAlPBxeDxPFO+GoVWCEvLlVLqiDoHbV4TMBb6TBcwwNCFcR1WSaa+IBwAphprAbENtd6U9Z/c5NcEJ8YrKilEfzkx02QJEAI6SVm0ILk0HxQUK4IUnvG6PJIn1UhH9I2ecct3DDz+QCxFCgIScF8bZATw0OuxUKRg6G9bGQ7CxQ+lntwMqekEwzGW7gb0xUQNX7JRxHmKYyUlwt0afJ/fWuC5PVOLsUuRAgISyQxRh4Y474eS9l4rgnzrr3TdsvP3GjrVlRg0C8Y3EFkPOak6sQL9R6gNPgYcDgf2zSIf6CE+lfAtvgK/GAzh7qLOvZpiLpqRvui815C8M3LXQf4dKcQNAoMNLl4ZEf8aWrXDImv0PbB548NrWUoxo+6fPn3XLlZOXbAUJuoBEIf0GAMkPiJsJru2YEbCIRPEksyZA0US78upqylltFysoY0U1DvnacK5sPECH14EZTSkFDRc3lvDFzEvgTRAYLIJrAxZ9YTICLXTW5dSBInBffMP2l73y1NVghja0WvR18Xe/ds+PLz73IYE3cxWNlb5xoq+rSyRYdeNLaLovtmFKKcD/81V2wlhQFlXOqQsFMNGrV24o0ZWCx5RSq6nDT3gwrruS8hxf3vtMWggVkteC76W0Ixo3Iw33UeSIJAjoCPpm7PnH73Sr/fLLLt78tS9/6h6A0t0K4dp52bDQ4wJDbB9Dn31lq2QVxebxkUs1eM6MDp5r8Nb+nIcmxAP6xgwti1UKHlEKViuWOZrBiTNpIdnFfEKSdvVWu9SYcTGER5Yip3NvF+QqJRE4vCArV65Iwe48Tr/xhmse/dzffnBjUFRJVngI/BTiiTsKnDrF80ZwY1Li+L19IwhaH5ELeuiosnxK2pUpjm9Q6zK2AYamwatLczAmFEiNGnp9i3RncnXkygMUdVA9KHsglAZhJglKI8+HV+UHxHqX4Iy0A5HKmF//8rIHiOg1btb0bN33Drrde/dt2z76/rffKJZ5XpRYPhv43YIf8Ll2W54r586twLulnFn+BtDn1m03RUqykcDX2EU16U1znvQk1vtUxd9bPkRs3BO02XK4tkjxBrB9gH98QTkokK0acWzU+MeSrZKEDATunqiCjIMyH/vIe29Zd8QRm1butjIp8jwMfpCIFYdmerpTvOm0/7X/oWuPnG0G+4yr/djW3ofOPM1X+cg5CExZBUhcwbVb8VC4u1TQEasPNy/VPWHGTZHIV75yxt+046ywHRpz+j1zPSch+tYK0VcOIfpdzp3C8RfWgQPKg6b9RzouL4msglZfwtVi2YZIFMzT43QFqQuDwP+XIhxyD9gAABi/SURBVAfD2ahbbr5+KoQ+26DDcyg5Vu25qjkfVVAUhT3rQ+++YXp6yufGBcosHSQlds4cTBk28c05k+a4FQQ3SF9txRvJ2A7w9k5ZCg1a6ZKpZKCQclOkGFmUzWeunYjxKoGHccXNMsUocuY76fWYdU6IGdPcoCuMl4vFGtaGhyJT1IDEqoXQoe5EfSrfIRj0sLpVqkiPWHf08j333L05H7H+l2edef3dd93RkWPKgt+vcmwUVLhAoNIgyKWHlbhJ2cpUhQGaqOxSBXIeYiSTNBUJq+nxrTXmwr2YhyZ9VyqYhOhV1OSwIP6N6EoJFt2Leu3hQW6XSnFfEGGSv+OJ9gL3JmHceJhQCevcggtr5bcEGizfLd8lljW+76ijj1kxH4L/4xc+ffOGa65ui67OSxgYPUZuFvQrBprywh2vIGIEYuWqU7yBJ9Buf35h+jkM0pTqU4FjMOXhVnLNAeC/h9AJ7bM/5qQaVvB+KCR6dZTzrHVg42NtrOvaHMn4Kh5s43R7SfzQddNl6ZFAgUknicsjFylEz4i+D3BkfeXKUDEOIfAUZDMcdtjhK+dK8Au+NXHnjy/5wUNy4eW7BPHCDQZ8MikER8o5hJ8rfE1fWcMXgkh8EIYlY6imhMBx2W5Mx+66a54tP9vanTfGJKNiqYBFdHrVAhyao1UKfhFH8CqaSlgZWue4zPo67V7hsd198eRQtMtJsm6mDYLcRH4767/Q10fDkF2gvi6R4Wo0GvqApzylNZcgzmWXXXrfud/8+ib5ThkgEMKWBKdmbfl33KDTXWd+xC4MS1Mm8sx1ufSfBS/p/HkzMljLEALX+1aXUyQYSh0FDIaEZ2LOtvbk+gW5PjiP3nP6I5UgzbIaKbtJ3G04pyySOWXa93Dxc8xEr8sGEF0n7beqrT+BOTvEx4VBHYnkFaaEzgd5bJ+Dx+888sj1y1MEFNXk8Gs3XP3wF7/wuY1ik4Ql1K4zdVl4YG0JwxbuZpcLOK4QDgTyHglLKgg3sKiQOGh07DldWqLxoCB3fWlO3AM15sCsYRGf8u3RkOiGa9HDVa1tG0B0nj/K+iYu23QxulX75+KPCtGtLQGBSCxKUJQFjSZs7y2lPWJM+cIAW+pypfrFO762bt0RtUX7XXfe3j7rrL+4STB4oXuZudkwdJxZ4ceH9G3a0KiEMqdgZYOKGpNNFOILZJgvxza8OEdmSYjQys1+dd2tNLc3u2IIfWCmUrUwCFP192bt1TI+1r43ieBOmUjoxlGKjgclG4FEEpcgFa7vqg6zSyFgMo5KsShtuCRcaQKfGN8jm0UNaPwr1vXatYfUMuIefeTB7vs/8EHyxXXQlFAaAgCUBhgDEiFwv/zx+PIj3piu1nz7kGp4vGLcOgSxglCUi+QUaFgSOYMucd03hjVyXFZpIGgESxcSvVq7NhwYqOCShAfNJkR4HjobK6nf9pUpykWR/IlCP4oGBFRY0aVleVNgnAW5aA+VDuei499brVa8/377LB9G8F53qvjIR//ielNk3lsIrGw//CcLmikwxLsv2NTlpoDgS4+3R/SGBA9bkfopUN7Y1Y55YmEgVH9Kc588vMaW3bDZVpV+W6q1bMC94sIMxsoartuFcjBJrHxBIfdf0W5aofZWO3EhX8igkRCEIVnRhWIDBHF4X/BYlJMZfNgytJTx/uj161oae+2aDGa7ffwTf33Dpvu2dOWExDbwXsAgHL7xLhuJ7WoIOdy8YXRRVFJUqX1zUkyVvWvYYEuIq5WOE4XXkhgL57tGGn45PtauelzVVW1I5EvPQ6JnTPhwzVogNz7W/m0Sw8YkcQRPkfA4ipI43+kiEVFujHWZkxE3S0Q8T0XkHmuOa4TTJZ0aBxAksQekpZhYw3KB1x0+XLR/7otfuunmW27bJpLDtQLxkUEirBQaig0inTKEcNIaVCKLUpHaC3S4GGbh7DduMU4qT2IZEc97E6PYMZNrNJzS2G4nRXn47mxLD+D0jYOIDgM6PFebCA5a/5rGQINlZUgNtdpMnCuXMLeLjsL2IIyI8ZOQwjJluXiyMaTU3NW8l50owIlUK4QoitKax88d+rQDZjXivnHeBbf/7OdXPix6Nw8I3uk5sEOllh5EpOPvchUq8GYx/LrhkiUPngjjBjaIwHlkMPAIb5rYHA7wJZXJYl3phledlCf5/hCaHFBBOU+H6rtK9JsrGbd9aoRkz2skqkdDZZNSp9MBJ2zc6XJCgqIIUxBr5hV2oBCrNwxw2EDE8gAAT2DgIkIR/Xut2jPdZ/XuozMR/IeX/Oe937nwkvvD0DA+7HCjw/B7ReJUja8q7k8KFsRNq2bLIt2PgwMR71HZ4524PA44PJGh/G5cNzPM+eNj7WHAiSqz3hLStUr09gCD7ojZvn18rP2w1vCd1I2cjNw8cTdwNglOQE4IbOm3R8FMFhHXPuJly3ClXOTg/Vb8dHkNiSUb6ah1h7Rm0uNX/vo3D3z5q+dTu0/2w32IVc5JjEQR0ZJACaOFsiHFRw9tirDnTMjxUhwixZnCBCGXJyWX88xWN56brylumn8eQnD0xw+pvNbXWnRQ3rwazz1yhlKucH0JD4gOLC0PlIbHkxGitN/N5YQFyR6JixWCBH3li0CIw4yciF6JhZPhpF2THnz/usMGi/abb71969/8/b/cGm6SsM2JcQSk18U3R4JLzF+qbvxUh8IRPGwcqJVvSgCDONs/ZrEesY8us1uFSZqpDOR3zJQmCrtV/mh8rL1xMAn8OowJL2sbT9YaSvQQN9ca0F+ub42PtW+LI/geDYoPuD2NXQKFnmNrbT6xiFAXCiSbxMNypLtUn2smc9UCzrGMQJWBOgI0NGJprz14v+2IvmXLA9Pv++jZ13v9rfxAAYmygagUcb8E6YqED3FsHJSxEsjhzpge1pWwZxJa6mKb+DamURk5THi4AHO2ZxZkHiJ+SvPZ8XOfGUJwYJx7uLZr8zqI6N0BTQOfWePHPttMlZVZ4Xhr8sGTOxcp5UZlaDTyOAXr9L0kIbJCBuVyFKvg2r1ALLLfbqXJAX6GuZYu5oH77z2yareRZijSp7Y9np3xkXM25EEYlXvE9In0Xv/4EMWh1e1EuQqAYZI4kRBsAAVToVqSSRWgSrHug1daq1J3AxltTZ6/TkyUEpdfPKQDNHDYtdo76Nrqm2aCRf12wJfNmoQZH2vfEWmYoINtuANtkGhyJ+BOSinplRrH4o/2D7tTQeclX85jS6L4IfhZ2drEcHgU3z/2jLW7hxxuTQZ/+rGvXPvIo9vyYLKyT/SIq5YVPsoHXCtvws0R6nJbMezCJSJciB1Cw0B60AViPY40MQMav0xk3Wjw4xQiZiLMi/zVbNefV3Uaxx2D2rzORPRNA3z2Ot2MPtNM1WOo10fckHi6uRNgS5QmLfiYvBLorDTvFzdNOk5JBweJ7fN4LFqSy5ZRXvjZre2pLCT6x/7u3667deOWqdw363HRMzG+wqrRPiPRlgEl4XgJyIRtwSTeHoAr+vR4CN8SgvvwKo8fYfuHOL3ZhGiEuRsl5UgDUxjw5fGxdpUe1bXXgPHmVw5642wTGDuVNuCruKnNjO7C+jW97oZ7Gg9qrV4WtCXxUTYnq6UKkzqigh9VaX2bLq/flSohz1zs59tzMUzKT1mQEq8bb920bbcVI6rT7eT/9M2f3v6zX93yiCRkTJDH9rh1VQIgeCP4IEonC4ANQY9X8SxwM4bdLvk3vErwVSuMK4gC9zWmoIt2hm/KQ3ebiu6X8dBdGr7bVOhNvWf9mt6w/PAJnEqVtYVz6Nut2cqabuUPhmIdG9Z9e8iPn5/G8JpmQz1XghYFdZwK+qa4Hmm49w2kRuMAgDhVSqoh88JNeKAGfdDfzYEG5XNSRoiIzf4FfIvi+O//+dI7IWzlAZRu8IZZlpc+tBEvwZYuZJH7Ag1vVEpDJOk0TQ2PbX8u30uMqmsWEDxigqexJqmH3D3iJCFJRST6aEr3MT4HgA+Mj7WHlY9jN4qnVV6bMQs3DOr8i8pzFB9Pme0DPAr6zJFUPU7johvOqEOr1Il60vFenOHIafHf8cIIIKHB8ClVwddpXaYfA2MJOOVpGZnj9bDUjXd5nGdHEjlsgbMuV/KeatsUcRGh3Cy+qEEkjqw+DEEg0kOCuybGmvADjViuiSd4TMRuOrEeR/C18bH25UNoBAOmZN4vgIlBaxjRbx3Q2uK4YZ8bH2tv0ho+QLu26eaE+3vZBKkLNiA3j6Q6wrAtOnBpwjB6xarA+vpuG/rVkmcXwypM3ohtIBtGdLJ0Z3YjMX3gREKpfRE4+Zz46xBEC0PggxxHXmlrGhptIcHRUnfGrUKDV5NIL2eqR47gKm6mCq/9J2oQ/NABafBZ0651pio/xAEaWdifpsfG3oxr/Zrezdfd29hNKXWML1AMmhSAr712lo8xruu5y1crgjhbbq4TBTl4v6yvavX6XgodxSgUo096x1KQRWLgnK8vLBuDpaj3q5CxWrYM1QYtSaXxr5/nxuAHPZPRhhw+kjLB0dhtgNfhyBSsx5NlTTWtFLxpfKw9rJAh5Tbg4UzWjQMkdN+qU6p8LwdsQqPuWI7nDpv68IlmCkdZq46RMZTGBkT320Ch2tcYWM6UsTgKA7siOm5xWwPLnTia50EWlNZUrqDA6r7YvPRoBcneEcKF9TtxdVHWn4n/PyjGHiJhjBvC7zNoUPaNoeH8Bc8UjCLnlUSqNNpIh7tImyf4siYTvEEGG91wE2gNZ9aAQgE3+G0Fz1ER/WTYh+r2IPspc7csLHL83WEfGh9rY2TvtJGGusXtZDqxaBmLejnJRoP8Uc7Qkd+KIpBSihKnr7p14rOLASd57RAKzRk4Et1iVOVBooSG3gYEl56uYTVtiOGXSQyy6cIomxh+hEfHOegSi0gcwRtpINKZ4E60uxtyOV6POIIPj4+1f1CDJmsGTFj8r5lmsYWr7tD8HkfqQj9wZU0x391wd+PSNFYn2f5d6cp0XAWmAChdgaIbO07sxM0UQZA3LK5lXKYb2xmkLAOIldJBkz6Jh0vINTdlo141ILPABp0Pp0LQ+1VcSRTlphx+X7pkLn6uHXcrjYRGQ3aUDTThcGYCcs2Wj+okjeHs8bH2F2rQA9Omr6uIdZS6F9WpV59Lt8FrBuDoXlAHLj0+1r4PFLxxWVNtJZ3FHL+8qeKm02lkwS5D6zVVMXJFQpEq4pAo4rGZeLmlPg6vOo6xlladRWBg5SwJBN9mAusbArEddnQKAzbkBWgv+n1xhg5UiC79cECcYFwS3Otvikg6j4UIjURfPooELsX5cvbJ0xi+CQCfrEmL4weglS+p2S+oNqfLupuNOhn7oTlhf8Owmerr1/Qe3nBP4xdprH4PFIxIyDVSPnmiJFbpesQq0o0WlI0jGlPpKz7w3XHkLWQxpHwvWWkWAMzhtpImDCtRJCiU88YIa+GgbCvijTWBd7tQMkKXXAVpEnJ3hNwN5KY2G6DFYxGVVhLbEbyRwIUA8L4aJUrAs1SruZCraxQ++DVXonc55x7ma5vM7cNKbJDwWzbc07gsjdWJoLhgUpoZ+BSjojpsAlYyYBrVJL6O1h4I4BIUFFgPC8p3rhIXjUW6R2d5wgYIQIFY6bIyxr1uyy4PElYNxb+zL1zTGw4Na0IJsbHWYCwBGmtox4w0WG+zKHe6WztLfVQnjQTOA4A/HR9r1+mwgK7ZiRUJjVi5C2u2IXHnMEeiA/cQX8FRIFkyJODOYR9ev6b34IZ7GhensXqx1rCnhCkjxY0sIqfQWQCQ3sS/UCoS3MXGSlnWpRQcwUQOhnW9wVeGc5UU9KP0oLJpxs5rHrAr6NckGBoEMs+Vj8016ldaR2iRKz9h2elup7c5JUrpUPa16cZiPV7W6OdwvE9i+Cx6ODU5fPcBehxtqn+bawsSZf99Lm/3Cwn8xgrhgfXKNXW+YGKyhYbgF7oZPG+qUw6J77rJwm7WegeKHg/mxUnNuXUDzDCw0s0J6io4dKfPOZ5O2Dseo0FzUYIOFtyaTFWzbTzn1Y8TyQsl0T8PU6bHjPZVoH0SyKWOHbc3HWKIjDfnnoFLMzeUpoib81h6WsP7x8fawwCOsrA7yB8MGIR/Yc3ZeX1rvkQH5vbxSjNhyxZkrQPhttWn5wWcMd2zMM3Ex1HSOH+9W1iT8cxRN7wXDA4UQP8eZ7JLPXc3d8N7pSTYOmOOmF7Gc0o2TcaBBIAI31E6hChTISb44BCJeHQnxYZwYE5XSBgzng2JXXK8D8JwtI2yjiju0f8+fXysfUvN65xyi88nVV7/1UwJlWFrIUQHPpBTKs2JCq6FriJrZ1zfuKL1bGPg89M9u9c0cTzQKG43g91Ndezy0H03nRCTHdbmiIY1bvB+twdGQj0YT4/IMDQkymkEluS0XeJHXD+rGY8n9eISrQNCwGgtBYkgYzWDEi4u8iAXzREbAlHvQBDI3Q0mfBLDBQDwZzUSKLLwur52wJDEm5jL57UWSnRgbPyrKwZywRxfdzcj12Na8Kw8h1dOIVd3nYjH2DeKfTTiSMz3bIHtOLu5G2nhsl2WmhJTdgvj4CgMjM9xGzHpxI8PYdUgGHQptTLl4AEqiOTCAw1luVESKS0NFYjDGQRBBE8Z01ZiCjCO/qhS8OfjY+25ECrhEOv+ldcxLvKtuu7ZoLUYRMe1DgBeXnkNL+nFdaz6cH39itbx1sLHOj27D85w7boNgLNGsbUMivXCARstETzjQX80IUpGhPEmAPDBG2rl5TJ41iNwI9bTGOtHglL/NmyuL7PUGLyZcgcIKdWiyhOGezsghAoBjB7xgpweR1SYcBaihudwGRrM4dUiUozFn8de1LzXYhEd1zEDpgJaDuH+eg7foy64anlzqqfebgyc3s3saKcHRZYT55N+x8F/BQVRbOFCrTxahOaSWl9MKOk53ByO02m0COXqJQ6fM4beGWcCZCunRTlXMqjKRYgyV45KcYdUnjQSF04mYGNMfjMS++o5XscVzOHVxhAP8hTFqTl+3/YXeBGJDjw96PgBr/+GEwF1fUkiyMRka3el4F1FAW/u5bbJnI8ERwuf7rOCrPlCZsq4ahca0o+cS5vDciNenD4hoVzF5VD+BzmMyiFhNzy3SnDtCO0JHjmCi3hnYmP162fGx9qXzuP67c0Er85938Ku2YIJDjuA6MDFES8fgJXfxHq+bodDYVQ9MdlaoRW82Rp4azeHPbrB2G4U+YLQMX6YEI2oNIW02i6ckUcpVsq/W9+JylrfA89RHLiLkxfnZYcN4nKMyMWO25NYKlBoIyDY4ZyaoIdB6xhu3BtV/oZ4hvMHNHmc99oRRAcunjupAroHrqnCDNJt8/nSizeMJg89Hh2vFJyaF/C8LLdu3GVh3cz2wrl0vvLUQbUklOrryz3YAoJKE3Dt0KTTRcS5cCXD+aUBQ+zcNBLpEWwBRfCxc2sUIcy08Bq9bIa6wduYUeZttA1aO4rowKHZkyv5XllXsa6f93ilicnWHkrBiWDhpThaOiug0TfUt7C+ltxtAia+wKoZw+FbyKsyxCoZOgkLS7g1pvJhuAsUXMZFhL+uGU2bae3DzFGdlgUcT//Jdm3eF2HtSKIDd0M4aYauFojj+uF82lxW18Rkq8FJCLoZA4cYC6tpYKCxvuacUTsDm+0KAqbs6kTELiIFd4IimwThxL9cAEeHC0X4sxlWXhXnmLi6dFCRwmKtHU104OTAizg7VF2Guf6KCkhjwWtisiXlWHJbzU0WlrFLNMJctJXjCo9wc93NnELGPMLN42PtBblHA9aTGa48aOg9Hsv35tMFci5rZxBd1kGsuwbNHMGEweU7cnfvAmsF4w8Om+FQMJ7xo8Xe/IPWziQ6cJz+hAEYbVlbGMk5L0NvF13LWJSvnwGTOM39Y+YUxFrI2tlEl3UIB3Kq/qiszaxDq00SnkhrBdeWHTXL4AQEn1y2WP533bVURAfWq89l/7RqzMh6lAM719cZEriLrP0YsHjILHC0LWyZD6tP2yFrKYkuC3PEzx/S36Zgrv9vxnUv3fS9wQtdrrWcg5itI9fjbLRuWIi7utC1KxBd1mqulatWXlZXh7N3t7OFvdjWdd21FxunTxuQ666uKZ6C+NthWMKdsXYlosvai3XhYbOIfVnSBXETu1mbmZsWe0V8XPuyy7WmxuRDYBfwKlZPS05sWbsi0WUtY+TtkTU6XIVrmnF8j7Dfu5U3whRLhYLDmqIiUta9Tfbdm2xg7saqZxXf14WLG64B3MCqaJczRHdloodrf+b8p9WZJrVE617u4nTjzrbG57qeKESXpXkDHMh4+0FRrZ21ety16Q6OK7SX8FjmtHbKrNVFXIZFpsS/l7OOfTLr2z0HZPYWa21lV+tevm1eSgt8IeuJxunDlmL3aRXfr+QgyUhwQ2mBwRIxElHPo95FzkV7AEUz3sQeQNsAbYQdHh7dKQsA/h99YWmieYKIJgAAAABJRU5ErkJggg==',
                    width: 120,
                    height: 120
                  },
                  left: 'center',
                  top: "center",
                  position: [100, 100]
                }]
              },
              polar: {
                radius: ["80%", "90%"],
                center: ["50%", "50%"],
              },
              angleAxis: {
                max: 100,
                show: false,
              },
              radiusAxis: {
                type: "category",
                show: true,
                axisLabel: {
                  show: false,
                },
                axisLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
              },
              series: [
                {
                  name: "",
                  type: "bar",
                  roundCap: true,
                  barWidth: 20,
                  showBackground: true,
                  backgroundStyle: {
                    color: "#2e2856",
                  },
                  data: [80],
                  coordinateSystem: "polar",
                  itemStyle: {
                    normal: {
                      color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                        {
                          offset: 0,
                          color: "#585fe1",
                        },
                        {
                          offset: 1,
                          color: "#0ff",
                        },
                      ]),
                    },
                  },
                },
                // {
                //   hoverAnimation: false,
                //   type: "pie",
                //   z: 1,
                //   data: labelData1,
                //   radius: ["50%", "55%"],
                //   zlevel: -2,
                //   itemStyle: {
                //     normal: {
                //       borderColor: "rgba(255, 255, 255,0)",
                //       borderWidth: 10,
                //     },
                //   },
                //   label: {
                //     normal: {
                //       position: "inside",
                //       show: false,
                //     },
                //   },
                // },
              ],
            }
          ]
        },
        // 能耗分布
        energyConsumptionDistribution: {
          id: 5,
          Title: ['能耗分布', '/Energy consumption distribution'],
          Option: {
            grid: {
              top: "10%",
              left: "5%",
              right: "15%",
              bottom: "10%",
            },
            tooltip: {
              show: false,
            },
            xAxis: {
              type: "value",
              min: 0,
              max: 100,
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#ffffff",
                  width: 1,
                },
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: "rgba(96,118,173,0.3)",
                },
              },
              axisLabel: {
                show: false,
              },
              axisTick: {
                show: false,
              },
            },
            yAxis: [{
              //show: false,
              type: "category",
              splitLine: {
                show: false,
              },
              axisLine: {
                show: false,
              },
              axisLabel: {
                show: true,
                interval: 0,
                margin: 0,
                align: "left",
                padding: [-35, 0, 0, 0],
                textStyle: {
                  color: "#bdd3ff",
                  fontSize: 13,
                },
              },
              axisTick: {
                show: false,
              },
              data: ["其他", "空调", "照明", "动力"],
            },
            {
              type: "category",
              inverse: false,
              data: ["50%", "40%", "30%", "20%"],
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                margin: 10,
                textStyle: {
                  color: "#fff",
                  fontSize: 13,
                },
              },
            },
            ],
            series: [
              {
                //真实数值条形图
                name: "真实值",
                type: "bar", //pictorialBar
                barWidth: "32%",
                itemStyle: {
                  color: function (params) {
                    if (params.name == "动力" || params.name == "照明") {
                      return "#ffb400"
                    } else if (params.name == "空调" || params.name == "其他") {
                      return "#2f6fff"
                    }
                  },
                },
                label: {
                  show: false,
                },
                data: [
                  {
                    name: "其他",
                    value: 50,
                  },
                  {
                    name: "空调",
                    value: 40,
                  },
                  {
                    name: "照明",
                    value: 30,
                  },
                  {
                    name: "动力",
                    value: 20,
                  }
                ],
                z: 1,
              },
              {
                //辅助方格图形
                name: "辅助值",
                type: "pictorialBar",
                barWidth: "32%",
                symbol: "rect",
                symbolRepeat: "true",
                symbolMargin: "80%",
                symbolSize: ["20%", "100%"],
                symbolOffset: ["150%", "0%"],
                symbolRepeat: true,
                itemStyle: {
                  normal: {
                    color: "rgba(10,16,30,1)",
                  },
                  barBorderRadius: 10,
                },
                label: {
                  normal: {
                    color: "#fff",
                    show: false,
                    position: ["100%", "10%"],
                    fontSize: 18,
                    formatter: function (params) {
                      console.info(params);
                      return " " + (value[params.dataIndex] * 100).toFixed(2) + "%";
                    },
                  },
                },
                data: [100, 100, 100, 100],
                z: 2,
              },
              {
                //辅助背景图形
                name: "背景条",
                type: "bar", //pictorialBar
                barWidth: "32%",
                barGap: "-100%",
                itemStyle: {
                  normal: {
                    borderWidth: 0,
                    color: "#535353",
                  },
                  barBorderRadius: 10,
                },
                data: [101, 101, 101, 101],
                z: 0,
              },
              //   {
              //     name: "外框",
              //     type: "bar",
              //     barGap: "-100%", // 设置外框粗细
              //     data: [100, 100, 100, 100],
              //     barWidth: 30,
              //     itemStyle: {
              //       normal: {
              //         color: "transparent", // 填充色
              //         barBorderColor: "#1C4B8E", // 边框色
              //         barBorderWidth: 2, // 边框宽度
              //         // barBorderRadius: 0, //圆角半径
              //         label: {
              //           // 标签显示位置
              //           show: false,
              //           position: "top", // insideTop 或者横向的 insideLeft
              //         },
              //       },
              //     },
              //     z: 0,
              //   },
            ],
          }
        },
        // 碳排放/标煤
        CarbonEmission: {
          id: 6,
          Title: ['碳排放/标煤', '/Carbon emission/standard coal'],
          data:{
            val:'1000/9000'
          }
        },
        // 负荷率
        LoadRate:{
          id: 7,
          Title: ['负荷率', '/Load rate'],
          Option:{
            color: ["#fff", "#0091ff", "#ff0017","#00ff7e","#f7c735"],
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                crossStyle: {
                  color: "#999",
                },
                lineStyle: {
                  type: "dashed",
                },
              },
            },
            grid: {
              left: "0%",
              right: "0%",
              bottom: "0%",
              top: "20%",
              containLabel: true,
            },
            xAxis: {
              type: "category",
              data: ["0:00", "3:00", "6:00", "9:00", "12:00", "15:00", "18:00", "21:00", "24:00"],
              splitLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                interval: 0, //强制显示文字
                fontStyle: {
                  fontSize: 12,
                },
                color: "#acbcd7",
              },
            },
            yAxis: {
              type: "value",
              name: '(%)',
              nameTextStyle: {
                color: "#acbcd7",
              },
              // max: max_value>=100? max_value + 100: max_value+10,
              // max: max_value > 100 ? max_value * 2 : max_value + 10,
              // interval: 10,
              //   nameLocation: "top",
              axisLabel: {
                fontStyle: {
                  fontSize: 12,
                },
                color: "#acbcd7",
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: "#5c6875",
                },
              },
              axisTick: {
                show: false,
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#5c6875",
                },
              },
            },
            series: [
              {
                name: "总数",
                type: "line",
                smooth: true,
                showSymbol: false,

                data: [90, 10, 40, 44, 45, 32, 76, 12, 30],
              },
              {
                name: "设备用房",
                type: "line",
                smooth: true,
                showSymbol: false,

                data: [80, 54, 34, 90, 40, 20, 90, 80, 70],
              },
              {
                name: "消防水泵房",
                type: "line",
                smooth: true,
                showSymbol: false,

                data: [80, 54, 34, 10, 20, 20, 90, 20, 70],
              },
              {
                name: "检查大厅",
                type: "line",
                smooth: true,
                showSymbol: false,

                data: [40, 54, 24, 10, 20, 20, 90, 70, 60],
              },
              {
                name: "海关查验库",
                type: "line",
                smooth: true,
                showSymbol: false,

                data: [50, 34, 64, 20, 20, 40, 60, 70, 90],
              },
            ],
          },
        },
        // 排行
        Ranking:{
          id: 8,
          Title: ['当月次数排行', '/Ranking of times in the month'],
          data1:[
            {
              xf:25,
              hg:25,
              sb:25,
              jc:25,
              sum:100
            },
            {
              xf:25,
              hg:25,
              sb:25,
              jc:24,
              sum:99
            }
          ],
          data2:[
            {
              color: ['#36ddff', '#2275ff', '#36ffc4', '#ffb400'],
              tooltip: {
                trigger: "item",
                position: function (pos, params, dom, rect, size) {
                },
                textStyle: {
                  color: '#fff'
                },
                formatter: (params)=>{
                  if(params.seriesName === 'val'){
                    return params.name + ':' + params.value
                  }
                }
              },
              graphic: {
                elements: [{
                  type: "image",
                  style: {
                    image: 'data:image/png;base64,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',
                    width: 95,
                    height: 95
                  },
                  left: 'center',
                  top: "center",
                  position: [100, 100]
                }]
              },
              title: {
                text: '{a|' + 100 + '}\n{b|总次数}',
                top: 'center',
                textAlign: "center",
                left: "48%",
                textStyle: {
                  color: "#fff",
                  rich: {
                    a: {
                      fontSize: 20,
                      lineHeight: 20,
                      fontWeight: 'bold'
                    },
                    b: {
                      fontSize: 15,
                      color:'#b4caf3'
                    }
                  }
                }
              },
              legend: {
                show: false,
              },
              toolbox: {
                show: false
              },
              series: [
                {
                  name: "val",
                  type: "pie",
                  radius: ['70%', '85%'],
                  center: ["50%", "50%"],
                  label: {
                    normal: {
                      show: false
                    }
                  },
                  hoverOffset: 5,
                  data: [
                    {
                      name: "消防水泵房",
                      value: 25,
                    },
                    {
                      name: "海关查验库",
                      value: 25
                    },
                    {
                      name: "设备用房",
                      value: 25
                    },
                    {
                      name: "检查大厅",
                      value: 25
                    },
                  ]
                },
                {
                  name: "",
                  type: "pie",
                  radius: ['92%', '90%'],
                  center: ["50%", "50%"],
                  label: {
                    normal: {
                      show: false
                    }
                  },
                  hoverAnimation: false,
                  color: 'rgb(66, 90, 114)',
                  data: [0]
                }
              ]
            },
            {
              color: ['#36ddff', '#2275ff', '#36ffc4', '#ffb400'],
              tooltip: {
                trigger: "item",
                position: function (pos, params, dom, rect, size) {
                },
                textStyle: {
                  color: '#fff'
                },
                formatter: (params)=>{
                  if(params.seriesName === 'val'){
                    return params.name + ':' + params.value
                  }
                }
              },
              graphic: {
                elements: [{
                  type: "image",
                  style: {
                    image: 'data:image/png;base64,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',
                    width: 95,
                    height: 95
                  },
                  left: 'center',
                  top: "center",
                  position: [100, 100]
                }]
              },
              title: {
                text: '{a|' + 99 + '}\n{b|总次数}',
                top: 'center',
                textAlign: "center",
                left: "48%",
                textStyle: {
                  color: "#fff",
                  rich: {
                    a: {
                      fontSize: 18,
                      lineHeight: 28,
                      fontWeight: 'bold'
                    },
                    b: {
                      fontSize: 12,
                      color:'#b4caf3'
                    }
                  }
                }
              },
              legend: {
                show: false,
              },
              toolbox: {
                show: false
              },
              series: [
                {
                  name: "val",
                  type: "pie",
                  radius: ['70%', '85%'],
                  center: ["50%", "50%"],
                  label: {
                    normal: {
                      show: false
                    }
                  },
                  // hoverAnimation: false,
                  hoverOffset: 5,
                  data: [
                    {
                      name: "消防水泵房",
                      value: 25,
                    },
                    {
                      name: "海关查验库",
                      value: 25
                    },
                    {
                      name: "设备用房",
                      value: 25
                    },
                    {
                      name: "检查大厅",
                      value: 24
                    },
                  ]
                },
                {
                  name: "",
                  type: "pie",
                  radius: ['92%', '90%'],
                  center: ["50%", "50%"],
                  label: {
                    normal: {
                      show: false
                    }
                  },
                  hoverAnimation: false,
                  color: 'rgb(66, 90, 114)',
                  data: [0]
                }
              ]
            },
          ]
        },
        // 建筑能耗
        BuildingEnergyConsumption: {
          id: 9,
          Title: ['建筑能耗', '/Building energy consumption'],
          Option: {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
              },
            },
            legend: {
              data: [],
            },
            grid: {
              left: "3%",
              right: "5%",
              top: "15%",
              bottom: "0%",
              containLabel: true,
            },
            xAxis: [
              {
                type: "category",
                data: ["消防水泵房", "海关查验库", "设备用房", "检测大厅"],
                splitLine: {
                  show: false,
                },
                axisLabel: {
                  interval: 0, //强制显示文字
                  fontStyle: {
                    fontSize: 12,
                  },
                  color: "#acbcd7",
                },
                splitLine: {
                  show: false,
                },
                axisLine: {
                  lineStyle: {
                    color: "#5c6875",
                  },
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "(Kwh)",
                nameTextStyle: {
                  color: "#acbcd7",
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    type: 'dashed',
                    color: "#5c6875",
                  },
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "#5c6875",
                  },
                },
                axisLabel: {
                  fontStyle: {
                    fontSize: 12,
                  },
                  color: "#acbcd7",
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            color: ["#fff"],
            series: [
              {
                name: "",
                type: "pictorialBar",
                barCategoryGap: "10%",
                // symbol: 'path://M0,10 L10,10 L5,0 L0,10 z',
                symbol: "path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z",
                itemStyle: {
                  color: 'rgba(255, 180, 0,.5)',
                  shadowBlur: 10,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
                label: {
                  normal: {
                    show: true,
                    position: "top",
                    textStyle: {
                      color: "#fff",
                      fontSize: 12,
                    },
                  },
                },
                data: [601, 325, 486, 531],
                z: 10,
              },
            ],
          }
        },
        // 三相不平衡度
        threePhaseUnbalance: {
          id: 10,
          Title: ['三相不平衡度', '/Three phase unbalance'],
          data: [
            {
              color: ["#2275ff", "#f7c735", "#FFB761"],
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "cross",
                  crossStyle: {
                    color: "#999",
                  },
                  lineStyle: {
                    type: "dashed",
                  },
                },
              },
              grid: {
                left: "0%",
                right: "0%",
                bottom: "0%",
                top: "15%",
                containLabel: true,
              },
              legend: {
                data: ["电压不平衡", "电流不平衡"],
                orient: "horizontal",
                icon: "rect",
                show: true,
                left: 'center',
                top: 0,
                textStyle: {
                  color: '#acbcd7',
                  fontSize: 10,

                },
                selectedMode: false,
                itemHeight: 10,//图例图标的高度
                itemWidth: 10,//图例图标的宽度
              },
              xAxis: {
                type: "category",
                data: ["0:00", "3:00", "6:00", "9:00", "12:00", "15:00", "18:00", "21:00", "24:00"],
                splitLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
                axisLabel: {
                  interval: 0, //强制显示文字
                  fontStyle: {
                    fontSize: 12,
                  },
                  color: "#acbcd7",
                },
              },
              yAxis: {
                type: "value",
                name: '%',
                nameTextStyle: {
                  color: "#acbcd7",
                },
                // max: max_value>=100? max_value + 100: max_value+10,
                // max: max_value > 100 ? max_value * 2 : max_value + 10,
                // interval: 10,
                //   nameLocation: "top",
                axisLabel: {
                  fontStyle: {
                    fontSize: 12,
                  },
                  color: "#acbcd7",
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: "#5c6875",
                  },
                },
                axisTick: {
                  show: false,
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "#5c6875",
                  },
                },
              },
              series: [
                {
                  name: "电压不平衡",
                  type: "line",
                  smooth: true,
                  showSymbol: false,

                  data: [13, 10, 40, 44, 45, 32, 76, 12, 30],
                },
                {
                  name: "电流不平衡",
                  type: "line",
                  smooth: true,
                  showSymbol: false,

                  data: [13, 54, 34, 90, 40, 20, 90, 80, 70],
                },
              ],
            },
            {
              color: ["#2275ff", "#f7c735", "#FFB761"],
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "cross",
                  crossStyle: {
                    color: "#999",
                  },
                  lineStyle: {
                    type: "dashed",
                  },
                },
              },
              grid: {
                left: "0%",
                right: "0%",
                bottom: "0%",
                top: "15%",
                containLabel: true,
              },
              legend: {
                data: ["电压不平衡", "电流不平衡"],
                orient: "horizontal",
                icon: "rect",
                show: true,
                left: 'center',
                top: 0,
                textStyle: {
                  color: '#acbcd7',
                  fontSize: 10,

                },
                selectedMode: false,
                itemHeight: 10,//图例图标的高度
                itemWidth: 10,//图例图标的宽度
              },
              xAxis: {
                type: "category",
                data: ["0:00", "3:00", "6:00", "9:00", "12:00", "15:00", "18:00", "21:00", "24:00"],
                splitLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
                axisLabel: {
                  interval: 0, //强制显示文字
                  fontStyle: {
                    fontSize: 12,
                  },
                  color: "#acbcd7",
                },
              },
              yAxis: {
                type: "value",
                name: '%',
                nameTextStyle: {
                  color: "#acbcd7",
                },
                // max: max_value>=100? max_value + 100: max_value+10,
                // max: max_value > 100 ? max_value * 2 : max_value + 10,
                // interval: 10,
                //   nameLocation: "top",
                axisLabel: {
                  fontStyle: {
                    fontSize: 12,
                  },
                  color: "#acbcd7",
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: "#5c6875",
                  },
                },
                axisTick: {
                  show: false,
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "#5c6875",
                  },
                },
              },
              series: [
                {
                  name: "电压不平衡",
                  type: "line",
                  smooth: true,
                  showSymbol: false,

                  data: [40, 10, 40, 44, 45, 92, 26, 12, 30],
                },
                {
                  name: "电流不平衡",
                  type: "line",
                  smooth: true,
                  showSymbol: false,

                  data: [13, 14, 34, 50, 40, 20, 90, 80, 70],
                },
              ],
            },
            {
              color: ["#2275ff", "#f7c735", "#FFB761"],
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "cross",
                  crossStyle: {
                    color: "#999",
                  },
                  lineStyle: {
                    type: "dashed",
                  },
                },
              },
              grid: {
                left: "0%",
                right: "0%",
                bottom: "0%",
                top: "15%",
                containLabel: true,
              },
              legend: {
                data: ["电压不平衡", "电流不平衡"],
                orient: "horizontal",
                icon: "rect",
                show: true,
                left: 'center',
                top: 0,
                textStyle: {
                  color: '#acbcd7',
                  fontSize: 10,

                },
                selectedMode: false,
                itemHeight: 10,//图例图标的高度
                itemWidth: 10,//图例图标的宽度
              },
              xAxis: {
                type: "category",
                data: ["0:00", "3:00", "6:00", "9:00", "12:00", "15:00", "18:00", "21:00", "24:00"],
                splitLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
                axisLabel: {
                  interval: 0, //强制显示文字
                  fontStyle: {
                    fontSize: 12,
                  },
                  color: "#acbcd7",
                },
              },
              yAxis: {
                type: "value",
                name: '%',
                nameTextStyle: {
                  color: "#acbcd7",
                },
                // max: max_value>=100? max_value + 100: max_value+10,
                // max: max_value > 100 ? max_value * 2 : max_value + 10,
                // interval: 10,
                //   nameLocation: "top",
                axisLabel: {
                  fontStyle: {
                    fontSize: 12,
                  },
                  color: "#acbcd7",
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: "#5c6875",
                  },
                },
                axisTick: {
                  show: false,
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "#5c6875",
                  },
                },
              },
              series: [
                {
                  name: "电压不平衡",
                  type: "line",
                  smooth: true,
                  showSymbol: false,

                  data: [40, 20, 40, 44, 45, 92, 26, 12, 70],
                },
                {
                  name: "电流不平衡",
                  type: "line",
                  smooth: true,
                  showSymbol: false,

                  data: [13, 44, 34, 50, 40, 20, 90, 30, 70],
                },
              ],
            },
            {
              color: ["#2275ff", "#f7c735", "#FFB761"],
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "cross",
                  crossStyle: {
                    color: "#999",
                  },
                  lineStyle: {
                    type: "dashed",
                  },
                },
              },
              grid: {
                left: "0%",
                right: "0%",
                bottom: "0%",
                top: "15%",
                containLabel: true,
              },
              legend: {
                data: ["电压不平衡", "电流不平衡"],
                orient: "horizontal",
                icon: "rect",
                show: true,
                left: 'center',
                top: 0,
                textStyle: {
                  color: '#acbcd7',
                  fontSize: 10,

                },
                selectedMode: false,
                itemHeight: 10,//图例图标的高度
                itemWidth: 10,//图例图标的宽度
              },
              xAxis: {
                type: "category",
                data: ["0:00", "3:00", "6:00", "9:00", "12:00", "15:00", "18:00", "21:00", "24:00"],
                splitLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
                axisLabel: {
                  interval: 0, //强制显示文字
                  fontStyle: {
                    fontSize: 12,
                  },
                  color: "#acbcd7",
                },
              },
              yAxis: {
                type: "value",
                name: '%',
                nameTextStyle: {
                  color: "#acbcd7",
                },
                // max: max_value>=100? max_value + 100: max_value+10,
                // max: max_value > 100 ? max_value * 2 : max_value + 10,
                // interval: 10,
                //   nameLocation: "top",
                axisLabel: {
                  fontStyle: {
                    fontSize: 12,
                  },
                  color: "#acbcd7",
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: "#5c6875",
                  },
                },
                axisTick: {
                  show: false,
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "#5c6875",
                  },
                },
              },
              series: [
                {
                  name: "电压不平衡",
                  type: "line",
                  smooth: true,
                  showSymbol: false,

                  data: [70, 70, 40, 44, 45, 92, 66, 12, 70],
                },
                {
                  name: "电流不平衡",
                  type: "line",
                  smooth: true,
                  showSymbol: false,

                  data: [20, 14, 54, 50, 80, 20, 90, 30, 70],
                },
              ],
            },
          ]
        },
        // 用能趋势分析
        EnergyConsumptionTrend: {
          id:11,
          Title: ['用能趋势分析', '/Energy trend analysis'],
          Option: {
            grid: {
                left: '0%',
                right: '0%',
                top: '15%',
                bottom: '0%',
                containLabel: true
            },
            tooltip: {
                show: true,
                trigger: 'axis',
            },
            legend: {
                show: false,
            },
            xAxis: { // 横坐标轴
              boundaryGap:false, // 不留白，从原点开始
              axisTick: {
                show: false,
              },
              axisLabel: {
                interval: 0,
                textStyle: {
                  color: "#acbcd7",
                  fontSize: 10,
                },
              },
              axisLine: {
                lineStyle: {
                  type: "solid",
                  color: "#45505d",
                  width: "1 ", //坐标线的宽度
                },
              },
                data: ['0:00', '3:00', '6:00', '9:00', '12:00', '15:00', '18:00', '21:00', '24:00']
            },
            yAxis:{
              name: "(Kwh)",
              nameTextStyle: {
                color: "#acbcd7",
              },
              axisTick: {
                show: false,
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: "#45505d", //网格横线颜色
                  width: 1,
                  type: "dashed",
                },
              },
              axisLabel: {
                textStyle: {
                  color: "#acbcd7",
                  fontSize: 10, //坐标值得具体的颜色
                },
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#45505d",
                },
              },
                },
            series: [
                {
                    name: '',
                    type: 'line',
                    smooth: true,
                    stack: '总量',
                    symbolSize: 0,
                    itemStyle: {
                        normal: {
                            color: 'rgb(255, 180, 0)',
                            lineStyle: {
                                color: "rgb(255, 180, 0)",
                                width: 2
                            },
                        }
                    },
                    areaStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: 'rgba(255, 180, 0, 1)'
                                },
                                {
                                  offset: 0.8,
                                  color: 'rgba(255, 180, 0, 0)'
                              },
                                {
                                    offset: 1,
                                    color: 'rgba(255, 180, 0, 0)'
                                }
                            ], false),
                        }
                    },
                    data: [220, 330, 191, 234, 290, 330, 310, 201, 154]
                }
                
            ]
          }
        },
      },
      pipeNetwork: {
        EquipmentStatistics: {
          id: 3,
          Title: ['设备状态统计', '/Equipment status statistics'],
          data: {
            // 设备总台数
            total: 1000,
            // 在线数
            onLine: 500,
            // 离线数
            offLine: 500,
            option: {
              color: ['#ffb400', '#488dff'],
              graphic: {
                elements: [{
                  type: "image",
                  style: {
                    image:'data:image/png;base64,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',
                    width: 60,
                    height: 60
                  },
                  left: 'center',
                top: "center",
                  position: [100, 100]
                }]
              },
              legend: {
                show: false,
              },
              toolbox: {
                show: false
              },
              series: [
                {
                  name: "val",
                  type: "pie",
                  radius: ['33', '40'],
                  center: ["50%", "50%"],
                  label: {
                    show: false,
                    position: 'center',
                    formatter:(params)=>{
                      return params.name + "\n" + params.value
                    },
                  },
                  emphasis: {
                    label: {
                      show: true,
                      fontSize: 12,
                      fontWeight: 'bold'
                    }
                  },
                  // hoverAnimation: false,
                  hoverOffset: 2,
                  data: [
                    {
                      name: "离线数",
                      value: 50,
                    },
                    {
                      name: "在线数",
                      value: 250
                    },
                  ]
                }
              ]
            }
          }
        },
        // 成本目标
        CostTarget: {
          id: 4,
          Title: ['成本目标', '/Cost target'],
          // 实际用能
          actual: 1000,
          // 目标用能
          target: 1000,
          // 同比 100%
          yearOnYear: 100,
          // 环比
          ringRatio: 100,
          data: [
            {
              graphic: {
                elements: [{
                  type: "image",
                  style: {
                    image: 'data:image/png;base64,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',
                    width: 120,
                    height: 120
                  },
                  left: 'center',
                  top: "center",
                  position: [100, 100]
                }]
              },
              polar: {
                radius: ["80%", "90%"],
                center: ["50%", "50%"],
              },
              angleAxis: {
                max: 100,
                show: false,
              },
              radiusAxis: {
                type: "category",
                show: true,
                axisLabel: {
                  show: false,
                },
                axisLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
              },
              series: [
                {
                  name: "",
                  type: "bar",
                  roundCap: true,
                  barWidth: 20,
                  showBackground: true,
                  backgroundStyle: {
                    color: "#2e2856",
                  },
                  data: [80],
                  coordinateSystem: "polar",
                  itemStyle: {
                    normal: {
                      color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                        {
                          offset: 0,
                          color: "#585fe1",
                        },
                        {
                          offset: 1,
                          color: "#0ff",
                        },
                      ]),
                    },
                  },
                },
                // {
                //   hoverAnimation: false,
                //   type: "pie",
                //   z: 1,
                //   data: labelData1,
                //   radius: ["50%", "55%"],
                //   zlevel: -2,
                //   itemStyle: {
                //     normal: {
                //       borderColor: "rgba(255, 255, 255,0)",
                //       borderWidth: 10,
                //     },
                //   },
                //   label: {
                //     normal: {
                //       position: "inside",
                //       show: false,
                //     },
                //   },
                // },
              ],
            }
          ]
        },
        // 碳排放、标煤
        CarbonEmission: {
          id: 5,
          Title: ['碳排放/标煤', '/Carbon emission/standard coal'],
          data: {
            val: '1000/9000',
          }
        },
        // 建筑能耗
        BuildingEnergyConsumption: {
          id: 6,
          Title: ['建筑能耗', '/Building energy consumption'],
          data: [
            {
              tooltip: {},
              grid: {
                left: "0%",
                right: "0%",
                bottom: "0%",
                top: "15%",
                containLabel: true,
              },
              xAxis: {
                data: ["消防水泵房", "海关查验房", "设备用房", "检测大厅"], //横坐标
                axisTick: {
                  show: false,
                },
                axisLabel: {
                  interval: 0,
                  textStyle: {
                    color: "#acbcd7",
                    fontSize: 10,
                  },
                },
                axisLine: {
                  lineStyle: {
                    type: "solid",
                    color: "#45505d",
                    width: "1  ", //坐标线的宽度
                  },
                },
              },
              yAxis: {
                name: "(Kwh)",
                nameTextStyle: {
                  color: "#acbcd7",
                },
                axisTick: {
                  show: false,
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: "#45505d", //网格横线颜色
                    width: 1,
                    type: "dashed",
                  },
                },
                axisLabel: {
                  textStyle: {
                    color: "#acbcd7",
                    fontSize: 10, //坐标值得具体的颜色
                  },
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "#45505d",
                  },
                },
              },
              series: [
                {
                  name: "",
                  type: "bar",
                  barWidth: "30%",
                  data: [601, 302, 486, 531], //数据
                  label: {
                    normal: {
                      show: true,
                      position: "top",
                      textStyle: {
                        color: "#fff",
                        fontSize: 12,
                      },
                    },
                  },
                  itemStyle: {
                    normal: {
                      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "#336ae3" }, //柱图渐变色
                        { offset: 0.8, color: "#336ae310" }, //柱图渐变色
                        { offset: 1, color: "#336ae300" }, //柱图渐变色
                      ]),
                    },
                    // 经过变色
                    // emphasis: {
                    //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    //     { offset: 0, color: "#336ae3" }, //柱图渐变色
                    //     { offset: 0.8, color: "#336ae310" }, //柱图渐变色
                    //     { offset: 1, color: "#336ae300" }, //柱图渐变色
                    //   ]),
                    // },
                  },
                },
              ],
            },
            {
              tooltip: {},
              grid: {
                left: "0%",
                right: "0%",
                bottom: "0%",
                top: "15%",
                containLabel: true,
              },
              xAxis: {
                data: ["消防水泵房", "海关查验房", "设备用房", "检测大厅"], //横坐标
                axisTick: {
                  show: false,
                },
                axisLabel: {
                  interval: 0,
                  textStyle: {
                    color: "#acbcd7",
                    fontSize: 10,
                  },
                },
                axisLine: {
                  lineStyle: {
                    type: "solid",
                    color: "#45505d",
                    width: "1  ", //坐标线的宽度
                  },
                },
              },
              yAxis: {
                name: "(Kwh)",
                nameTextStyle: {
                  color: "#acbcd7",
                },
                axisTick: {
                  show: false,
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: "#45505d", //网格横线颜色
                    width: 1,
                    type: "dashed",
                  },
                },
                axisLabel: {
                  textStyle: {
                    color: "#acbcd7",
                    fontSize: 10, //坐标值得具体的颜色
                  },
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "#45505d",
                  },
                },
              },
              series: [
                {
                  name: "",
                  type: "bar",
                  barWidth: "30%",
                  data: [701, 502, 786, 431], //数据
                  label: {
                    normal: {
                      show: true,
                      position: "top",
                      textStyle: {
                        color: "#fff",
                        fontSize: 12,
                      },
                    },
                  },
                  itemStyle: {
                    normal: {
                      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "#336ae3" }, //柱图渐变色
                        { offset: 0.8, color: "#336ae310" }, //柱图渐变色
                        { offset: 1, color: "#336ae300" }, //柱图渐变色
                      ]),
                    },
                    // 经过变色
                    // emphasis: {
                    //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    //     { offset: 0, color: "#336ae3" }, //柱图渐变色
                    //     { offset: 0.8, color: "#336ae310" }, //柱图渐变色
                    //     { offset: 1, color: "#336ae300" }, //柱图渐变色
                    //   ]),
                    // },
                  },
                },
              ],
            },
            {
              tooltip: {},
              grid: {
                left: "0%",
                right: "0%",
                bottom: "0%",
                top: "15%",
                containLabel: true,
              },
              xAxis: {
                data: ["消防水泵房", "海关查验房", "设备用房", "检测大厅"], //横坐标
                axisTick: {
                  show: false,
                },
                axisLabel: {
                  interval: 0,
                  textStyle: {
                    color: "#acbcd7",
                    fontSize: 10,
                  },
                },
                axisLine: {
                  lineStyle: {
                    type: "solid",
                    color: "#45505d",
                    width: "1  ", //坐标线的宽度
                  },
                },
              },
              yAxis: {
                name: "(Kwh)",
                nameTextStyle: {
                  color: "#acbcd7",
                },
                axisTick: {
                  show: false,
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: "#45505d", //网格横线颜色
                    width: 1,
                    type: "dashed",
                  },
                },
                axisLabel: {
                  textStyle: {
                    color: "#acbcd7",
                    fontSize: 10, //坐标值得具体的颜色
                  },
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "#45505d",
                  },
                },
              },
              series: [
                {
                  name: "",
                  type: "bar",
                  barWidth: "30%",
                  data: [503, 402, 186, 231], //数据
                  label: {
                    normal: {
                      show: true,
                      position: "top",
                      textStyle: {
                        color: "#fff",
                        fontSize: 12,
                      },
                    },
                  },
                  itemStyle: {
                    normal: {
                      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "#336ae3" }, //柱图渐变色
                        { offset: 0.8, color: "#336ae310" }, //柱图渐变色
                        { offset: 1, color: "#336ae300" }, //柱图渐变色
                      ]),
                    },
                    // 经过变色
                    // emphasis: {
                    //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    //     { offset: 0, color: "#336ae3" }, //柱图渐变色
                    //     { offset: 0.8, color: "#336ae310" }, //柱图渐变色
                    //     { offset: 1, color: "#336ae300" }, //柱图渐变色
                    //   ]),
                    // },
                  },
                },
              ],
            }
          ]
        },
        // 用能趋势分析
        EnergyConsumptionTrend: {
          id: 7,
          Title: ['用能趋势分析', '/Energy trend analysis'],
          Option:{
              grid: {
                  left: '0%',
                  right: '4%',
                  top: '15%',
                  bottom: '0%',
                  containLabel: true
              },
              tooltip: {
                  show: true,
                  trigger: 'axis',
              },
              legend: {
                  show: false,
              },
              xAxis: { // 横坐标轴
                boundaryGap:false, // 不留白，从原点开始
                axisTick: {
                  show: false,
                },
                axisLabel: {
                  interval: 0,
                  textStyle: {
                    color: "#acbcd7",
                    fontSize: 10,
                  },
                },
                axisLine: {
                  lineStyle: {
                    type: "solid",
                    color: "#45505d",
                    width: "1 ", //坐标线的宽度
                  },
                },
                  data: ['0:00', '3:00', '6:00', '9:00', '12:00', '15:00', '18:00', '21:00', '24:00']
              },
              yAxis:{
                name: "(Kwh)",
                nameTextStyle: {
                  color: "#acbcd7",
                },
                axisTick: {
                  show: false,
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: "#45505d", //网格横线颜色
                    width: 1,
                    type: "dashed",
                  },
                },
                axisLabel: {
                  textStyle: {
                    color: "#acbcd7",
                    fontSize: 10, //坐标值得具体的颜色
                  },
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "#45505d",
                  },
                },
                  },
              series: [
                  {
                      name: '',
                      type: 'line',
                      smooth: true,
                      stack: '总量',
                      symbolSize: 0,
                      itemStyle: {
                          normal: {
                              color: 'rgb(255, 180, 0)',
                              lineStyle: {
                                  color: "rgb(255, 180, 0)",
                                  width: 2
                              },
                          }
                      },
                      areaStyle: {
                          normal: {
                              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                  {
                                      offset: 0,
                                      color: 'rgba(255, 180, 0, 1)'
                                  },
                                  {
                                    offset: 0.8,
                                    color: 'rgba(255, 180, 0, 0)'
                                },
                                  {
                                      offset: 1,
                                      color: 'rgba(255, 180, 0, 0)'
                                  }
                              ], false),
                          }
                      },
                      data: [220, 330, 191, 234, 290, 330, 310, 201, 154]
                  }
                  
              ]
          }
        },
      },
      maintain:{
        EquipmentStatistics: {
          id: 3,
          Title: ['设备状态统计', '/Equipment status statistics'],
          data: {
            // 设备总台数
            total: 1000,
            // 在线数
            onLine: 500,
            // 离线数
            offLine: 500,
            option: {
              color: ['#ffb400', '#488dff'],
              graphic: {
                elements: [{
                  type: "image",
                  style: {
                    image:'data:image/png;base64,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',
                    width: 60,
                    height: 60
                  },
                  left: 'center',
                top: "center",
                  position: [100, 100]
                }]
              },
              legend: {
                show: false,
              },
              toolbox: {
                show: false
              },
              series: [
                {
                  name: "val",
                  type: "pie",
                  radius: ['33', '40'],
                  center: ["50%", "50%"],
                  label: {
                    show: false,
                    position: 'center',
                    formatter:(params)=>{
                      return params.name + "\n" + params.value
                    },
                  },
                  emphasis: {
                    label: {
                      show: true,
                      fontSize: 12,
                      fontWeight: 'bold'
                    }
                  },
                  // hoverAnimation: false,
                  hoverOffset: 2,
                  data: [
                    {
                      name: "离线数",
                      value: 50,
                    },
                    {
                      name: "在线数",
                      value: 250
                    },
                  ]
                }
              ]
            }
          }
        },
        // 用能趋势分析
        EnergyConsumptionTrend: {
          id: 4,
          Title: ['用能趋势分析', '/Energy trend analysis'],
          Option:{
              grid: {
                  left: '0%',
                  right: '5%',
                  top: '15%',
                  bottom: '0%',
                  containLabel: true
              },
              tooltip: {
                  show: true,
                  trigger: 'axis',
              },
              legend: {
                  show: false,
              },
              xAxis: { // 横坐标轴
                boundaryGap:false, // 不留白，从原点开始
                axisTick: {
                  show: false,
                },
                axisLabel: {
                  interval: 0,
                  textStyle: {
                    color: "#acbcd7",
                    fontSize: 10,
                  },
                },
                axisLine: {
                  lineStyle: {
                    type: "solid",
                    color: "#45505d",
                    width: "1  ", //坐标线的宽度
                  },
                },
                  data: ['0:00', '3:00', '6:00', '9:00', '12:00', '15:00', '18:00', '21:00', '24:00']
              },
              yAxis:{
                name: "(Kwh)",
                nameTextStyle: {
                  color: "#acbcd7",
                },
                axisTick: {
                  show: false,
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: "#45505d", //网格横线颜色
                    width: 1,
                    type: "dashed",
                  },
                },
                axisLabel: {
                  textStyle: {
                    color: "#acbcd7",
                    fontSize: 10, //坐标值得具体的颜色
                  },
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "#45505d",
                  },
                },
                  },
              series: [
                  {
                      name: '',
                      type: 'line',
                      smooth: true,
                      stack: '总量',
                      symbolSize: 0,
                      itemStyle: {
                          normal: {
                              color: 'rgb(255, 180, 0)',
                              lineStyle: {
                                  color: "rgb(255, 180, 0)",
                                  width: 2
                              },
                          }
                      },
                      areaStyle: {
                          normal: {
                              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                  {
                                      offset: 0,
                                      color: 'rgba(255, 180, 0, 1)'
                                  },
                                  {
                                    offset: 0.8,
                                    color: 'rgba(255, 180, 0, 0)'
                                },
                                  {
                                      offset: 1,
                                      color: 'rgba(255, 180, 0, 0)'
                                  }
                              ], false),
                          }
                      },
                      data: [220, 330, 191, 234, 290, 330, 310, 201, 154]
                  }
                  
              ]
          }
        },
        AirConditioningStatus:{
          id:5,
          Title: ['空调开关状态', '/Air conditioning switch status'],
          data1:{
            text:'消防水泵房',
            onLine:54,
            outLine:54,
            option:{
              color: ['#ffb400', '#2f6fff'],
              title: {
                text: '{a|' + 121 + '}\n{b|总数}',
                top: 'center',
                textAlign: "center",
                left: "45%",
                textStyle: {
                  color: "#fff",
                  rich: {
                    a: {
                      fontSize: 18,
                      lineHeight: 24,
                      fontWeight: 'bold'
                    },
                    b: {
                      fontSize: 14,
                      color:'#92a7c9'
                    }
                  }
                }
              },
              legend: {
                show: false,
              },
              toolbox: {
                show: false
              },
              series: [
                {
                  name: "",
                  type: "pie",
                  radius: ['62%', '52%'],
                  center: ["50%", "50%"],
                  label: {
                    normal: {
                      show: false
                    }
                  },
                  // hoverAnimation: false,
                  hoverOffset: -8,
                  data: [
                    {
                      name: "在线",
                      value: 30,
                    },
                    {
                      name: "离线",
                      value: 70
                    },
                   
                  ]
                },
              ]
            }
          },
          data2:{
            text:'海关查验房',
            onLine:54,
            outLine:54,
            option:{
              color: ['#ffb400', '#2f6fff'],
              title: {
                text: '{a|' + 121 + '}\n{b|总数}',
                top: 'center',
                textAlign: "center",
                left: "45%",
                textStyle: {
                  color: "#fff",
                  rich: {
                    a: {
                      fontSize: 18,
                      lineHeight: 24,
                      fontWeight: 'bold'
                    },
                    b: {
                      fontSize: 14,
                      color:'#92a7c9'
                    }
                  }
                }
              },
              legend: {
                show: false,
              },
              toolbox: {
                show: false
              },
              series: [
                {
                  name: "",
                  type: "pie",
                  radius: ['52%', '62%'],
                  center: ["50%", "50%"],
                  label: {
                    normal: {
                      show: false
                    }
                  },
                  // hoverAnimation: false,
                  hoverOffset: 0,
                  data: [
                    {
                      name: "在线",
                      value: 30,
                    },
                    {
                      name: "离线",
                      value: 70
                    },
                   
                  ]
                },
              ]
            }
          },
          data3:{
            text:'设备用房',
            onLine:54,
            outLine:54,
            option:{
              color: ['#ffb400', '#2f6fff'],
              title: {
                text: '{a|' + 121 + '}\n{b|总数}',
                top: 'center',
                textAlign: "center",
                left: "45%",
                textStyle: {
                  color: "#fff",
                  rich: {
                    a: {
                      fontSize: 18,
                      lineHeight: 24,
                      fontWeight: 'bold'
                    },
                    b: {
                      fontSize: 14,
                      color:'#92a7c9'
                    }
                  }
                }
              },
              legend: {
                show: false,
              },
              toolbox: {
                show: false
              },
              series: [
                {
                  name: "",
                  type: "pie",
                  radius: ['62%', '52%'],
                  center: ["50%", "50%"],
                  label: {
                    normal: {
                      show: false
                    }
                  },
                  // hoverAnimation: false,
                  hoverOffset: -8,
                  data: [
                    {
                      name: "在线",
                      value: 30,
                    },
                    {
                      name: "离线",
                      value: 70
                    },
                   
                  ]
                },
              ]
            }
          },
          data4:{
            text:'检查大厅',
            onLine:54,
            outLine:54,
            option:{
              color: ['#ffb400', '#2f6fff'],
              title: {
                text: '{a|' + 121 + '}\n{b|总数}',
                top: 'center',
                textAlign: "center",
                left: "45%",
                textStyle: {
                  color: "#fff",
                  rich: {
                    a: {
                      fontSize: 18,
                      lineHeight: 24,
                      fontWeight: 'bold'
                    },
                    b: {
                      fontSize: 14,
                      color:'#92a7c9'
                    }
                  }
                }
              },
              legend: {
                show: false,
              },
              toolbox: {
                show: false
              },
              series: [
                {
                  name: "",
                  type: "pie",
                  radius: ['62%', '52%'],
                  center: ["50%", "50%"],
                  label: {
                    normal: {
                      show: false
                    }
                  },
                  // hoverAnimation: false,
                  hoverOffset: -8,
                  data: [
                    {
                      name: "在线",
                      value: 30,
                    },
                    {
                      name: "离线",
                      value: 70
                    },
                   
                  ]
                },
              ]
            }
          },
        },
        // 建筑能耗
        BuildingEnergyConsumption: {
          id: 6,
          Title: ['建筑能耗', '/Building energy consumption'],
          data: [
            {
              tooltip: {},
              grid: {
                left: "0%",
                right: "0%",
                bottom: "0%",
                top: "15%",
                containLabel: true,
              },
              xAxis: {
                data: ["消防水泵房", "海关查验房", "设备用房", "检测大厅"], //横坐标
                axisTick: {
                  show: false,
                },
                axisLabel: {
                  interval: 0,
                  textStyle: {
                    color: "#acbcd7",
                    fontSize: 10,
                  },
                },
                axisLine: {
                  lineStyle: {
                    type: "solid",
                    color: "#45505d",
                    width: "1  ", //坐标线的宽度
                  },
                },
              },
              yAxis: {
                name: "(Kwh)",
                nameTextStyle: {
                  color: "#acbcd7",
                },
                axisTick: {
                  show: false,
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: "#45505d", //网格横线颜色
                    width: 1,
                    type: "dashed",
                  },
                },
                axisLabel: {
                  textStyle: {
                    color: "#acbcd7",
                    fontSize: 10, //坐标值得具体的颜色
                  },
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "#45505d",
                  },
                },
              },
              series: [
                {
                  name: "",
                  type: "bar",
                  barWidth: "30%",
                  data: [601, 302, 486, 531], //数据
                  label: {
                    normal: {
                      show: true,
                      position: "top",
                      textStyle: {
                        color: "#fff",
                        fontSize: 12,
                      },
                    },
                  },
                  itemStyle: {
                    normal: {
                      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "#336ae3" }, //柱图渐变色
                        { offset: 0.8, color: "#336ae310" }, //柱图渐变色
                        { offset: 1, color: "#336ae300" }, //柱图渐变色
                      ]),
                    },
                    // 经过变色
                    // emphasis: {
                    //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    //     { offset: 0, color: "#336ae3" }, //柱图渐变色
                    //     { offset: 0.8, color: "#336ae310" }, //柱图渐变色
                    //     { offset: 1, color: "#336ae300" }, //柱图渐变色
                    //   ]),
                    // },
                  },
                },
              ],
            },
            {
              tooltip: {},
              grid: {
                left: "0%",
                right: "0%",
                bottom: "0%",
                top: "15%",
                containLabel: true,
              },
              xAxis: {
                data: ["消防水泵房", "海关查验房", "设备用房", "检测大厅"], //横坐标
                axisTick: {
                  show: false,
                },
                axisLabel: {
                  interval: 0,
                  textStyle: {
                    color: "#acbcd7",
                    fontSize: 10,
                  },
                },
                axisLine: {
                  lineStyle: {
                    type: "solid",
                    color: "#45505d",
                    width: "1  ", //坐标线的宽度
                  },
                },
              },
              yAxis: {
                name: "(Kwh)",
                nameTextStyle: {
                  color: "#acbcd7",
                },
                axisTick: {
                  show: false,
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: "#45505d", //网格横线颜色
                    width: 1,
                    type: "dashed",
                  },
                },
                axisLabel: {
                  textStyle: {
                    color: "#acbcd7",
                    fontSize: 10, //坐标值得具体的颜色
                  },
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "#45505d",
                  },
                },
              },
              series: [
                {
                  name: "",
                  type: "bar",
                  barWidth: "30%",
                  data: [701, 502, 786, 431], //数据
                  label: {
                    normal: {
                      show: true,
                      position: "top",
                      textStyle: {
                        color: "#fff",
                        fontSize: 12,
                      },
                    },
                  },
                  itemStyle: {
                    normal: {
                      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "#336ae3" }, //柱图渐变色
                        { offset: 0.8, color: "#336ae310" }, //柱图渐变色
                        { offset: 1, color: "#336ae300" }, //柱图渐变色
                      ]),
                    },
                    // 经过变色
                    // emphasis: {
                    //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    //     { offset: 0, color: "#336ae3" }, //柱图渐变色
                    //     { offset: 0.8, color: "#336ae310" }, //柱图渐变色
                    //     { offset: 1, color: "#336ae300" }, //柱图渐变色
                    //   ]),
                    // },
                  },
                },
              ],
            },
            {
              tooltip: {},
              grid: {
                left: "0%",
                right: "0%",
                bottom: "0%",
                top: "15%",
                containLabel: true,
              },
              xAxis: {
                data: ["消防水泵房", "海关查验房", "设备用房", "检测大厅"], //横坐标
                axisTick: {
                  show: false,
                },
                axisLabel: {
                  interval: 0,
                  textStyle: {
                    color: "#acbcd7",
                    fontSize: 10,
                  },
                },
                axisLine: {
                  lineStyle: {
                    type: "solid",
                    color: "#45505d",
                    width: "1  ", //坐标线的宽度
                  },
                },
              },
              yAxis: {
                name: "(Kwh)",
                nameTextStyle: {
                  color: "#acbcd7",
                },
                axisTick: {
                  show: false,
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: "#45505d", //网格横线颜色
                    width: 1,
                    type: "dashed",
                  },
                },
                axisLabel: {
                  textStyle: {
                    color: "#acbcd7",
                    fontSize: 10, //坐标值得具体的颜色
                  },
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: "#45505d",
                  },
                },
              },
              series: [
                {
                  name: "",
                  type: "bar",
                  barWidth: "30%",
                  data: [503, 402, 186, 231], //数据
                  label: {
                    normal: {
                      show: true,
                      position: "top",
                      textStyle: {
                        color: "#fff",
                        fontSize: 12,
                      },
                    },
                  },
                  itemStyle: {
                    normal: {
                      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "#336ae3" }, //柱图渐变色
                        { offset: 0.8, color: "#336ae310" }, //柱图渐变色
                        { offset: 1, color: "#336ae300" }, //柱图渐变色
                      ]),
                    },
                    // 经过变色
                    // emphasis: {
                    //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    //     { offset: 0, color: "#336ae3" }, //柱图渐变色
                    //     { offset: 0.8, color: "#336ae310" }, //柱图渐变色
                    //     { offset: 1, color: "#336ae300" }, //柱图渐变色
                    //   ]),
                    // },
                  },
                },
              ],
            }
          ]
        },
        // 成本目标
        CostTarget: {
          id: 4,
          Title: ['成本目标', '/Cost target'],
          // 实际用能
          actual: 1000,
          // 目标用能
          target: 1000,
          // 同比 100%
          yearOnYear: 100,
          // 环比
          ringRatio: 100,
          data: [
            // {
            //   graphic: {
            //     elements: [{
            //       type: "image",
            //       style: {
            //         image: "data:image/png;base64,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",
            //         width: 120,
            //         height: 120
            //       },
            //       left: 'center',
            //       top: "center",
            //       position: [100, 100]
            //     }]
            //   },
            //   polar: {
            //     radius: ["80%", "90%"],
            //     center: ["50%", "50%"],
            //   },
            //   angleAxis: {
            //     max: 100,
            //     show: false,
            //   },
            //   radiusAxis: {
            //     type: "category",
            //     show: true,
            //     axisLabel: {
            //       show: false,
            //     },
            //     axisLine: {
            //       show: false,
            //     },
            //     axisTick: {
            //       show: false,
            //     },
            //   },
            //   series: [
            //     {
            //       name: "",
            //       type: "bar",
            //       roundCap: true,
            //       barWidth: 20,
            //       showBackground: true,
            //       backgroundStyle: {
            //         color: "#2e2856",
            //       },
            //       data: [80],
            //       coordinateSystem: "polar",
            //       itemStyle: {
            //         normal: {
            //           color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
            //             {
            //               offset: 0,
            //               color: "#585fe1",
            //             },
            //             {
            //               offset: 1,
            //               color: "#0ff",
            //             },
            //           ]),
            //         },
            //       },
            //     },
            //     // {
            //     //   hoverAnimation: false,
            //     //   type: "pie",
            //     //   z: 1,
            //     //   data: labelData1,
            //     //   radius: ["50%", "55%"],
            //     //   zlevel: -2,
            //     //   itemStyle: {
            //     //     normal: {
            //     //       borderColor: "rgba(255, 255, 255,0)",
            //     //       borderWidth: 10,
            //     //     },
            //     //   },
            //     //   label: {
            //     //     normal: {
            //     //       position: "inside",
            //     //       show: false,
            //     //     },
            //     //   },
            //     // },
            //   ],
            // }
          ]
        },
       
      },
      monitor:{
        EquipmentStatistics: {
          id: 3,
          Title: ['设备状态统计', '/Equipment status statistics'],
          data: {
            // 设备总台数
            total: 1000,
            // 在线数
            onLine: 500,
            // 离线数
            offLine: 500,
            option: {
              color: ['#ffb400', '#488dff'],
              graphic: {
                elements: [{
                  type: "image",
                  style: {
                    image:'data:image/png;base64,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',
                    width: 60,
                    height: 60
                  },
                  left: 'center',
                top: "center",
                  position: [100, 100]
                }]
              },
              legend: {
                show: false,
              },
              toolbox: {
                show: false
              },
              series: [
                {
                  name: "val",
                  type: "pie",
                  radius: ['33', '40'],
                  center: ["50%", "50%"],
                  label: {
                    show: false,
                    position: 'center',
                    formatter:(params)=>{
                      return params.name + "\n" + params.value
                    },
                  },
                  emphasis: {
                    label: {
                      show: true,
                      fontSize: 12,
                      fontWeight: 'bold'
                    }
                  },
                  // hoverAnimation: false,
                  hoverOffset: 2,
                  data: [
                    {
                      name: "离线数",
                      value: 50,
                    },
                    {
                      name: "在线数",
                      value: 250
                    },
                  ]
                }
              ]
            }
          }
        },
      }
    }
  },
  actions: {


  }
})
export default useStore
